export const Paper = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      fill="none"
      viewBox="93.7 86.7 468.44 486.54"
    >
      <path
        fill="#fff"
        fillOpacity="0.08"
        stroke="#fff"
        strokeMiterlimit="10"
        strokeOpacity="0.2"
        strokeWidth="0.603"
        d="M94.606 87h377.788c.337 0 .606.263.606.591V107H94V87.591c0-.328.27-.591.606-.591z"
      ></path>
      <path fill="url(#paint0_linear_711_10271)" d="M93.744 103.871H473.34900000000005V335.916H93.744z"></path>
      <path
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.603"
        d="M469.353 332.763H97.867a.944.944 0 01-.946-.946V106.938h373.378v224.879a.944.944 0 01-.946.946v0z"
      ></path>
      <path
        fill="#2FAF08"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.603"
        d="M108.693 101.725a5.166 5.166 0 100-10.332 5.166 5.166 0 000 10.332z"
      ></path>
      <path
        fill="#68C74A"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.603"
        d="M125.74 101.725a5.165 5.165 0 005.165-5.166 5.165 5.165 0 10-10.331 0 5.166 5.166 0 005.166 5.166z"
      ></path>
      <path
        fill="#CFFAC2"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.603"
        d="M142.786 101.725a5.166 5.166 0 100-10.332 5.166 5.166 0 000 10.332z"
      ></path>
      <g filter="url(#filter0_b_711_10271)">
        <path
          fill="#fff"
          fillOpacity="0.1"
          d="M210.595 189h302.81c.331 0 .595.347.595.78V216H210v-26.22c0-.433.265-.78.595-.78z"
        ></path>
        <path
          stroke="#fff"
          strokeMiterlimit="10"
          strokeOpacity="0.2"
          strokeWidth="0.603"
          d="M210.595 189h302.81c.331 0 .595.347.595.78V216H210v-26.22c0-.433.265-.78.595-.78v0z"
        ></path>
      </g>
      <path
        fill="#1854DF"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.603"
        d="M210.165 209.761h304.818v230.074a.944.944 0 01-.946.946H211.111a.943.943 0 01-.946-.946V209.761z"
      ></path>
      <path
        fill="#7B0AF2"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.603"
        d="M222.208 204.426a5.286 5.286 0 100-10.572 5.286 5.286 0 000 10.572z"
      ></path>
      <path
        fill="#29AB00"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.603"
        d="M239.646 204.426a5.287 5.287 0 100-10.574 5.287 5.287 0 000 10.574z"
      ></path>
      <path
        fill="#8EB3FF"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.603"
        d="M257.091 204.426a5.287 5.287 0 10-.001-10.573 5.287 5.287 0 00.001 10.573z"
      ></path>
      <path
        fill="#000"
        d="M164.992 126.191H120.2a6.366 6.366 0 00-6.366 6.366V233.57a6.366 6.366 0 006.366 6.366h44.792a6.366 6.366 0 006.366-6.366V132.557a6.366 6.366 0 00-6.366-6.366zM465.465 258.911v130.08c0 13.309-10.79 24.093-24.093 24.093h-1.465c-32.188 0-2.224-92.81-39.97-92.81H266.808v-61.363a5.199 5.199 0 015.202-5.202h188.253a5.203 5.203 0 015.202 5.202z"
      ></path>
      <path
        fill="#000"
        d="M376.121 413.084v-22.659c-.361-34.129 3.949-70.151 23.816-70.151 37.746 0 7.782 92.81 39.97 92.81h-63.786z"
      ></path>
      <path
        fill="#000"
        d="M376.127 390.425v22.659l-.024 27.697H177.446v-79.38c0-22.712 18.415-41.127 41.127-41.127h181.364c-19.867 0-24.177 36.022-23.81 70.151z"
      ></path>
      <path fill="url(#pattern0)" d="M255.192 245.355H460.04V410.854H255.192z"></path>
      <path
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.603"
        d="M456.894 253.576v130.08c0 13.309-10.79 24.093-24.093 24.093h-1.465c-32.189 0-2.224-92.81-39.97-92.81h-133.13v-61.363a5.199 5.199 0 015.202-5.201h188.254a5.202 5.202 0 015.202 5.201v0z"
      ></path>
      <path
        fill="#00D28A"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.603"
        d="M367.55 407.749v-22.658c-.362-34.13 3.948-70.152 23.815-70.152 37.746 0 7.782 92.81 39.971 92.81H367.55z"
      ></path>
      <path
        fill="url(#paint1_linear_711_10271)"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.603"
        d="M367.556 385.091v22.659l-.024 106.384H168.874V356.067c0-22.712 18.415-41.127 41.128-41.127h181.364c-19.868 0-24.178 36.022-23.81 70.151z"
      ></path>
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="0.603"
        d="M279.387 271.299h156.355M279.387 286.724h156.355M279.387 302.143h156.355M198.458 332.993h156.355M191.442 348.418h156.349M188.055 363.843h156.348M400.829 317.567h34.913M410.076 332.993h25.666M412.547 348.418h23.195M413.578 364.066h22.164M414.621 379.72h21.121"
      ></path>
      <path
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.603"
        d="M215.951 469.365s7.698 11.345 29.434 15.395c21.736 4.051 24.937-33.99 24.937-33.99l-54.371 18.595z"
      ></path>
      <path
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.603"
        d="M206.331 453.885s6.233 12.207 27.306 18.916c21.073 6.703 28.939-30.652 28.939-30.652l-56.251 11.736h.006z"
      ></path>
      <path
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.603"
        d="M205.264 435.694s2.544 13.472 20.88 25.835c18.331 12.369 36.402-21.26 36.402-21.26l-57.276-4.575h-.006z"
      ></path>
      <path
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.603"
        d="M210.496 415.285s-2.435 13.49 10.265 31.591c12.707 18.102 41.598-6.853 41.598-6.853l-51.863-24.738z"
      ></path>
      <path
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.603"
        d="M225.101 396.345s-7.703 11.338-3.448 33.038c4.256 21.7 40.79 10.633 40.79 10.633l-37.342-43.671v0z"
      ></path>
      <path
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.603"
        d="M246.699 385.212s-11.748 7.064-16.98 28.547c-5.233 21.483 32.58 26.751 32.58 26.751l-15.6-55.304v.006z"
      ></path>
      <path
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.603"
        d="M267.657 383.029s-13.496 2.399-26.058 20.597 20.868 36.625 20.868 36.625l5.19-57.228v.006z"
      ></path>
      <path
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.603"
        d="M291.901 391.1s-13.086-4.087-32.616 6.287c-19.53 10.368 1.657 42.122 1.657 42.122l30.959-48.409v0z"
      ></path>
      <path
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.603"
        d="M307.465 405.308s-10.766-8.493-32.713-5.78c-21.947 2.712-13.502 39.934-13.502 39.934l46.209-34.154h.006z"
      ></path>
      <path
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.603"
        d="M317.314 427.105s-6.389-12.128-27.541-18.572c-21.151-6.444-28.559 31.007-28.559 31.007l56.1-12.435v0z"
      ></path>
      <path
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.603"
        d="M316.995 451.402s-.718-13.689-17.222-28.403c-16.504-14.714-38.927 16.185-38.927 16.185l56.149 12.218z"
      ></path>
      <path
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.603"
        d="M309.068 470.926s4.226-13.044-5.937-32.682c-10.157-19.639-42.14 1.205-42.14 1.205l48.071 31.477h.006z"
      ></path>
      <path
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.603"
        d="M292.052 487.732s9.156-10.199 7.854-32.279c-1.308-22.074-38.994-16.016-38.994-16.016l31.146 48.289-.006.006z"
      ></path>
      <path
        fill="url(#paint2_linear_711_10271)"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.603"
        d="M258.598 444.302l-21.736 8.607 47.523 120.031 7.703-44.057 35.769 26.842-47.523-120.031-21.736 8.608z"
      ></path>
      <path
        fill="url(#paint3_linear_711_10271)"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.603"
        d="M260.032 444.778l-21.567-9.029-49.85 119.078 36.287-26.136 6.842 44.195L281.6 453.808l-21.568-9.03z"
      ></path>
      <path
        fill="#2AAC02"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.603"
        d="M259.653 479.612c21.845 0 39.554-17.709 39.554-39.554 0-21.845-17.709-39.554-39.554-39.554-21.846 0-39.555 17.709-39.555 39.554 0 21.845 17.709 39.554 39.555 39.554z"
      ></path>
      <path
        fill="#fff"
        stroke="#231F20"
        strokeMiterlimit="10"
        strokeWidth="0.603"
        d="M259.653 472.042c17.664 0 31.983-14.319 31.983-31.983s-14.319-31.984-31.983-31.984-31.984 14.32-31.984 31.984 14.32 31.983 31.984 31.983z"
      ></path>
      <path
        fill="#2AAC02"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.603"
        d="M259.653 464.935c13.739 0 24.876-11.138 24.876-24.877 0-13.739-11.137-24.876-24.876-24.876s-24.877 11.137-24.877 24.876 11.138 24.877 24.877 24.877z"
      ></path>
      <path fill="#000" d="M284.403 470.927l-24.274 34.165 11.435-27.312s6.95-1.669 12.839-6.853z"></path>
      <g filter="url(#filter1_b_711_10271)">
        <path
          fill="#fff"
          fillOpacity="0.08"
          d="M514.977 349.003c25.88 0 46.86-20.98 46.86-46.86s-20.98-46.86-46.86-46.86-46.86 20.98-46.86 46.86 20.98 46.86 46.86 46.86z"
        ></path>
        <path
          stroke="#fff"
          strokeMiterlimit="10"
          strokeOpacity="0.3"
          strokeWidth="0.603"
          d="M514.977 349.003c25.88 0 46.86-20.98 46.86-46.86s-20.98-46.86-46.86-46.86-46.86 20.98-46.86 46.86 20.98 46.86 46.86 46.86z"
        ></path>
      </g>
      <g filter="url(#filter2_b_711_10271)">
        <path
          fill="#fff"
          fillOpacity="0.08"
          d="M514.977 337.706c19.642 0 35.564-15.923 35.564-35.564s-15.922-35.564-35.564-35.564c-19.641 0-35.564 15.923-35.564 35.564s15.923 35.564 35.564 35.564z"
        ></path>
        <path
          stroke="#fff"
          strokeMiterlimit="10"
          strokeOpacity="0.3"
          strokeWidth="0.603"
          d="M514.977 337.706c19.642 0 35.564-15.923 35.564-35.564s-15.922-35.564-35.564-35.564c-19.641 0-35.564 15.923-35.564 35.564s15.923 35.564 35.564 35.564z"
        ></path>
      </g>
      <path
        fill="#92FED8"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.603"
        d="M529.776 317.436c7.573-6.833 7.088-19.714-1.084-28.77-8.171-9.056-20.934-10.858-28.507-4.025s-7.088 19.714 1.083 28.77c8.171 9.056 20.935 10.858 28.508 4.025z"
      ></path>
      <path
        fill="#92FED8"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.603"
        d="M532.472 314.433c7.573-6.833 7.045-19.762-1.18-28.877-8.225-9.115-21.031-10.965-28.604-4.132s-7.045 19.762 1.18 28.877c8.225 9.116 21.031 10.966 28.604 4.132z"
      ></path>
      <path
        fill="#92FED8"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.603"
        d="M528.451 309.034c5.096-4.598 4.74-13.299-.795-19.434-5.535-6.134-14.154-7.38-19.25-2.781-5.097 4.599-4.741 13.3.794 19.434 5.535 6.135 14.154 7.38 19.251 2.781z"
      ></path>
      <path
        fill="#fff"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.603"
        d="M171.08 132.231h-44.792a6.365 6.365 0 00-6.365 6.366V239.61a6.365 6.365 0 006.365 6.366h44.792a6.366 6.366 0 006.366-6.366V138.597a6.366 6.366 0 00-6.366-6.366z"
      ></path>
      <path
        fill="#2AAC02"
        fillRule="evenodd"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.603"
        d="M144.546 200.562l-4.183.036a2.05 2.05 0 00-2.032 2.062l.055 6.142a2.054 2.054 0 002.061 2.031l4.183-.036v1.025l-6.22.048a2.052 2.052 0 00-2.032 2.068l.055 6.142a2.054 2.054 0 002.061 2.031l6.233-.054.042 4.768a2.042 2.042 0 002.062 2.031l8.01-.066a2.054 2.054 0 002.032-2.062l-.38-45.636a16.43 16.43 0 005.461-3.683c6.384-6.492 6.299-16.95-.193-23.339-6.492-6.39-16.95-6.299-23.339.192-6.384 6.492-6.299 16.951.193 23.334a16.356 16.356 0 005.744 3.659l.181 19.307h.006zm11.26-29.446a7.718 7.718 0 00-.09-10.91 7.72 7.72 0 00-10.911.09c-2.984 3.032-2.947 7.921.091 10.911 3.038 2.983 7.926 2.941 10.91-.091v0z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#2AAC02"
        stroke="#fff"
        strokeMiterlimit="10"
        strokeWidth="0.603"
        d="M512.608 449.093c19.086 0 34.558-15.471 34.558-34.557 0-19.085-15.472-34.557-34.558-34.557-19.085 0-34.557 15.472-34.557 34.557 0 19.086 15.472 34.557 34.557 34.557z"
      ></path>
      <path
        fill="#fff"
        d="M509.908 431.842a4.179 4.179 0 01-2.869-1.139l-12.327-11.592a4.19 4.19 0 01-.187-5.919 4.19 4.19 0 015.919-.181l8.909 8.373 16.764-22.466c1.38-1.85 4.014-2.236 5.859-.85a4.187 4.187 0 01.856 5.859l-19.573 26.227a4.23 4.23 0 01-3.357 1.688h.006z"
      ></path>
      <path
        fill="#000"
        d="M376.127 407.749c0-46.407-2.158-86.98 10.862-92.17-9.819 3.713-16.823 16.624-18.505 42.369-1.772 27.083-.934 49.801-.934 49.801s8.577 2.146 8.577 0z"
      ></path>
      <defs>
        <filter
          id="filter0_b_711_10271"
          width="336.603"
          height="59.602"
          x="193.699"
          y="172.699"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="8"></feGaussianBlur>
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_711_10271"></feComposite>
          <feBlend in="SourceGraphic" in2="effect1_backgroundBlur_711_10271" result="shape"></feBlend>
        </filter>
        <pattern id="pattern0" width="1" height="1" patternContentUnits="objectBoundingBox">
          <use transform="scale(.00141 .00175)" xlinkHref="#image0_711_10271"></use>
        </pattern>
        <filter
          id="filter1_b_711_10271"
          width="122.323"
          height="122.323"
          x="453.816"
          y="240.981"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="7"></feGaussianBlur>
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_711_10271"></feComposite>
          <feBlend in="SourceGraphic" in2="effect1_backgroundBlur_711_10271" result="shape"></feBlend>
        </filter>
        <filter
          id="filter2_b_711_10271"
          width="99.731"
          height="99.731"
          x="465.112"
          y="252.277"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="7"></feGaussianBlur>
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_711_10271"></feComposite>
          <feBlend in="SourceGraphic" in2="effect1_backgroundBlur_711_10271" result="shape"></feBlend>
        </filter>
        <linearGradient
          id="paint0_linear_711_10271"
          x1="39.5"
          x2="495.5"
          y1="371"
          y2="186"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1" stopColor="#33B00D"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_711_10271"
          x1="264.5"
          x2="283.051"
          y1="517.93"
          y2="310.664"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#65FEC8"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint2_linear_711_10271"
          x1="286.658"
          x2="255.518"
          y1="446.954"
          y2="575.242"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2AAC02"></stop>
          <stop offset="1" stopColor="#7EEF5C"></stop>
        </linearGradient>
        <linearGradient
          id="paint3_linear_711_10271"
          x1="239.5"
          x2="209"
          y1="447"
          y2="575.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2AAC02"></stop>
          <stop offset="1" stopColor="#7EEF5C"></stop>
        </linearGradient>
        <image
          id="image0_711_10271"
          width="708"
          height="572"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAsQAAAI8CAYAAAD2lL33AAAACXBIWXMAABcRAAAXEQHKJvM/AAAgAElEQVR4Xu3dW5IsO5aYZ8SpqqaJZJMyDYDvlBknQ02Hr63ZqDUZmorP3QMQi5QZm9VW5XqIEyf9AmBdsHDx8P87dnJHhgMLC/BLrPCMnfu1bduWgv0x/Sn9l+2/pf8n/Sn9l+1PmRavzHN5+pZvlvbltvktMbHz7O2vPUoxXplH1+9qz+dG+2ypPV8fL9f3PFK+Te772LHOW6R4+zXWtc1lnfs+v/euj6/x8o/r+ZXalR/X8qvlVItfjxkRL7c91z8XP99ON4a0XTOuLifdtv32+jq8fvvGmke+T228Un7nr6e+r31G5+3+9Tg+9/OMNd5+y/65/ffy+S6dl9f40vi57blt5+/1betj5lrU256fubaxPeePV3o+F1NS71Heah/Jl99Is7L7vdRA6++3f0yvlNLfb/8gtNRPVd/yzdLe0jYle3sLa2xr+zbv0bYUP24+5vFZzbhRbbx6xW21n3PpsUdrf639GK/LM5FGzSiGNVt9+3fLYnt9oIN8F0cgJVtkW2staan224/tLD3928utpP4+loiWtmsaN4NxI/W3wlyaC+K/2/5z4S7wWCss5sdKufzQZVVqpesdpX5Rjiqkta2kdtoo32LUXK/r2nOlpdj27fojUjqaZb3b/2b79U9X557qCeW2ap/zkOJI2+ukvSdtl7bmHfvExbe0nSm3qlG5x63mvaw2M3dB/PfbP6b/W7wb7LfSQvXMxRrb2r4kKs4MI3KXX1JGKGewz6/0uNWIMWquY4wYtUaaubTd4ydmj+h7tfiXbapkyg3ErmZbSturObBqWt2tkUVdPUfLDCxtV3PNfdxMvCPN/rjE3NHrzAXxH9Of0v/51/8sNXMbsVg9x+gZu6Y+rjcrbz8/zcu/Z0s7bWxbO23rM08fjX0++zF6jZfSnHFGiHmh9PbTH4kf5hfKLaWUXuIguTysuY3SMyd9bE1LaQV7l2r12JaxLG1n6pVnPW6vUce6yyxMBXHvj0d4F83bT6Nn7Eily6M/f3/PH8esvC+Mtjaa1vcXOctSrP3zmjZeETHGWSvbyGy2tKVSUVwdQ0giKr+62ihtGcReVyNF7v03fUT52v4ExzmPWwHvSOY3vQ3GjRTnF6nBx99t/zn9cfvT+6ZAB97Fs/aztrewxra292kfpRTBGtn+wtLraOtrRNaeC/E+rx459og5jm4NS3Jz96yHp49FPX55DcS8Nk2jftr23jd67b7q6dt7rkBvlrb30WNWPWL29dr9f0fiHeI/pj+lv9/+Mf3xYXeGU+of36qWz2q5znZej/pLvbx671a6ttqY+nZX2vsz/hHspHFK26V+9+GZib+wmC17bHU94FrP4nwbTT+N1+7r8TkLe48Z7pHl+jzr6OmTUkq97w73jT5GtSD+Y/pT+rvQzwtfl8yziJ4+Kfn7afSMPcor8yhS7kVLfi7/Uie9AJ63S+0lLX3LY/ujal92/SPYV0zqsd9ui+w3apwo8vkwg3H0z53iSrceR2wkfxaaq1eUfpEltY/XnOla3VmPGfaI2c+9si2rfmSiVAxH/WTMs4iePinZ+1nbW1njW9vXRMYaw3rEWdvL4iOOcde8nyr3Rsd6vkbu86ZYxc75GeWe1c69pa+WLl5uD/a3H6dlzKb9jWVp37w8XbEg/rst8s7wlWf3ePqk5O93d755+3qV9bnEnrO0fu+37b7WyC2+mTR7aftYcUdHXj7+KmsQmccl1pZ7Mj+m9rmVSEdOv/yPI/cbx05ak7W0Zuvv7+np6QO9bEH8+Qt0NS0noGenevqk5Otn7WNtD7vtdMSdjz/p+zpbazxZ6Wy3XwVG3rWZfoR3TmC7PJjHe7fW0jYl7zj1lto4tXa+XfDafT0/u//+OrI25/v4vhndxaUg/mP6k1gMe72Sb1d7+qTk73cuvmbzzsOu70gt0Vv6puS9SN9B68oggmcvaO+Itjx3ZcvUXz79bDsUq9t5a4yIeMcY+QJtv61Etx+u9v1KxW7EPGu23deaWgtLjpa2Frq4ulZlrf1zyjG9o/V+4903+liXgjj2L9EhJ/oAiogXEUMiX2b9zvlbv59FV1LU1FdVF+O79J6zrRhtzyYXYdSdMttclQwB8nOXn5G2vSrb3rSl4VWP/XDUfwRI2Aff6FAQ//32j6V2WdaLxeg7r2NHu4f4959rGLuvr6N5x6/108Ws7zddjL6kHKTtqxlzpvyMoi1K77SO2+5u8Ud9XWNXXbtW9lFHv8rl2LO28o7g7Wc1fx/E8q5b77vD3+ZUEP9DqV0g+6Fq79FuhctaSv4TYS3xa3lel+s62cactc72e1s2ETFajchhxBifUWxH1punj1XbGuh761sqCAtjXbdcbtrntC2kwl2O3Vv722yJN4q3X7yWvdTSFyv7rSC23h3+8B3gvl6rWnE2nLI2s94A9X7piojR6ppDzNEZEyWCJ5N8H1/x9ma9axy5rek4+/VucVOMX4XnZtb7SqI5GjRtxpj19mDOqD98x0Bs1iPWvv8IY+0K4hF3h/cHiu+QsRozyjdgpWz6r9fIi81+NjHnqDd7b7+alnmMpS3otKukbbeEzERvlf+v7pjzKDPX5lV9lGuXo5uBrhVW80tK/rvD7fQvVPqWcXq/128zJrennNgrznPMHr6KWYs+2ftyK/fyxdPqG/2sz2i6qLpWKVVb6oMU2QucddwlT4s+V4E4tjeg99lDI+4Of6NfUnr/qrUW1oP+2N7ae009ZsEh/Wyz9n/+brH1GO+TvS2Hj3Ivfbw+8/Ga8Wa9NqK2sIi01h5Bznr76JhRrzdQ9mM/YlS0ehfEnX7vsJ7u8NG1uvL2S2nOC8930q9j3KVBP+a2+7oKOZu4ldrbRy099pLmJG338d8hlvORInyPrjN1BC8W4b9tcAQtiIskH1FR4nK+6hl7TfNmPG/kulXzavFL693hD+tpfm1vjYCUbAelpe3HU/bK+UdinrWKFpGDJ4bmDrF8XMgtxjnmYlkTS9sPaebSdo16XqWt8t0xvVrv89m0V559Wz5vxxi+lY7IY6RSvr7Z6/SMfScrrgMfl/D75Y/bf5PaDLTi4aUXmX2PQ9qTX4881rVlHvVVW9+IHCJi5MjHhdziW0kzl7a/afZcqY3uec0Ie73bW9XK7n0L+7Yry8q1zdveu9RDO0P7iNrYulbjePPx9sPdXP6lupHyJ6Ln9JS1RI3+2ERstO93vhw94/IU8z5fG0Pb7kM+huUWI1nnd+Tp7emTZ4+k66FrVReyl39NJCRWRW6+EWsQxTv//Rz2Vw1tvGN/LX3Lb6BdS63j6sWtZcyrhmzMKOP9Evnr1uIOmnKkuDH6WDk/+SCOyV4ep01MlnW957Aa65rK6yO3kMZs3b5nadtq232VWp3Jq6Zxjf3afY0UGXFGrNxekPacRDv2mbdf6x3ivda5r8uzGin1O3Owoql3iOviT82WiNF3iXs6nrzj8+79dmbExSkmU1nvcXrF38ftNUYk7zHjmZt3rCvP6CnlMuhR+IVQLpay2W9Gz9ea38e1XznSfotmPM98PeWfrXVOe4Q+Vs0LvYQWxJ7Dp37S5rd6TvSRVs9vJZ5jxmbO3mgftf4WTBtfu77ldtqR1jangP8ZSbsfRnplHsV4zzsyaq99FpXj8fjSZ3s9LqXbCddWpTlEzU2in23dOV9N/po2EaLmiLWFFsR9xB6KsdHmGnUxsLLkFbE/LOON0jun6PgR+yGluDhWliLEIuozebPf2kfMIiKGl3Vsbftxe0CmzbmNfhRty327fm+y9OfitVW+Zz2abqx20eP0P6KjM17JEgWxvAvlFiP0etF9slVPrta8eh8p2vjadlG86yblKW3Xvlha5c7540hSZm99stPTZVl3jBEQ8bIokauUK4s0rdqzaO3fl36/6Vv+8PSZ5U65YowlCmKd8MtxV1J+0vaningxiYgh848St+/lSNoste0kckZ99HqzmlsX20jl1ro1t42WUmSRd+xV+y5Gea7WVdi2a4/cK0gubnnLtZW0Jd/K8my0iP0WEeOqz/zLuXq2rGxE1iPGmOlGBXFKUadMTJS+YnPUXeLfdK3uxHMSe1bB06c3bU7adsjzHGO9xO3LWqTGUSYsWK6g710UxURp58ljTJ9X5tFTyDOWWyDSzQrilJovxI163YkaYdTJZVmhc1tLX61R+2zU+rbJr0VU7lFxxtLd7fu4zrHlCNP3vI6r/2ykfpS33vvRGr/WXhvruAbSTQLrikWaOTZW4jsSfL0k2vPszsIK4tbFsu1C6WKGmfrcdRnb194jhv2e3PVZz3nh6ZMTFadGGkPavmdpW9P3eGm/3lnzaxlL9IqNHxlLY/R4Odb9uVfv2xL5QxdD16qFfYTS30WwR4oxa9ynCiuIx2u7LLX0brkfNNM9s7aLmGdEjHb6LPQtV3aPy39urXPP/cym397R5rLa2kZmExkrTvubmJpecUvWXOM7u9eK3itbvxsXxCmtXpqultu3HtQ91tmzVrV7tT1y3LPl2/fF+qN3/BFy62pbaw3dSmlzyeenG+Mjfo792GbWbv7abBNzmDcyLOLOiift8ZsXxCm17Hh/zxht4z/pMB2vbd98jNpHa78x1BtTqLeq3w2u07aLZxu52z74NY1u8QeIyT0mSivbUfHm6ZOzxgoAP76gII46PW2+pQS5o1VX/nokRmQaEWM+3Sx6nsu6DM60vXLtjs/Ziv34ldCO7GPNt9beGqun+qr1XdN4MSsbNevW3x2u/emI9jlcPW2dvqAg/l5RFx67eSPfmXfVav28MUu2zCMLfS99y54sWZTbHrdoX2BtLya58jmSLRtba2W+u6Ajj3mt67izMrmz8pFjPabuwDMnTx+McfOCuP3Qarnk9b5L3D67vb65yvSzOWc6IvOIMa4zlOYcMepHZKwyaUY/yi33mUpZt27X55v32n39kMas0RbOrXmXjByrJj9mbrXHWWVtZtHesdW1urpe11vOJMja1te7n+8spCCOWri23fd9nroeUcdTzZi1jRolHycqusW1mC1loctO2tet23VZvOlK+BmkWer1msk1Q89I5SOq/Nxxi2fUD+24+u1S7yNpL0vb32xjzqQtwH3ssfvmgzsIKYjvjFNgPbGX9PcePsccsd9j56GxZR7V8tBlWGoVfz/vOpKUobTdkp0U68MS00abgUfrUWB1WqV+iybyFLpakdOSSvuonP2us7XM39JWY/56tFg7++h9dRc3LojX2GVzfuyzxtytSlnPWMEZY+7lS9fSMz/PavMecYRsl692usLd7y4xe6vlXD9Waj3vuBLrks5ZaTv68Ky7p08f9nN0ndzHu3FBjCieE8DTx2/saLPVZqtdCe1lcP+GrndxKpHmJr35lLfbt+aelfJcUS1nad18djGXXbAe8+5nfrZtGbT1Bvq7aUG87BX24g4XAX0poN0634j8zmP4xzz29N6T28QWOfHnkjWDD2+/D+kzgNJMc9ulPmPYVibX2hahbo01idA+k7Y3E7a+7dnqY+TbaXvjrp6+h29aEMd4+s4fp/9K215aYvSfVX/7OYx7Eeyzt6TiRBpV2j6SrqiVZoy6/qvX4+wZLWoOrXH67y2b1vlILPEtbVHWXBCP3xHXEVc7UfbGr4+dJ0dPn28z/rirj+jZJ/uI8fPZHPF997kxjmnfvHzH5Ypy85Z+KmFaqy/Xuhae42jdn/qk1L4iP9puBbytsy7zNBfE0XS77j6k+Ujb45QP93E5+J1z1OUce4rrxvRqj75lHuW0j7RXW+PjNsvekNq2zkHbX9vuHvSz0beUXWNxZ3sF0jn2JNIbm9W1Zt/a/1ssVxDXfd9us8/I3kMSHzHejBxjXrR1UWqtjtt08dbgz9zS1kN752jGcddOt3r6vSPHk1s8k3T8SNu/SetcOcbQ280KYrQoXVBWvND47gjfl/fF4q7rMidv7T30saJyycWJiS0fnfqfE5Sfu6OY9S2LWKeIGHq9V2SssWv3Y+S4I8da3Y0K4tjdFhvNT7p8SNvXJ690/QVT7u91l6LbWmy86e//zbZKbiPy6DlGv8JTvnsst9iLyaqnnvtJb40s8A04ljRuVBA/09yXjnkn0byRv8dd1tB2jOtmpWs1nm2ub9o7v9rnvFyxsp3ynyF2xa/YtuiIZ+t+8tSal3cmlhW2tH2Ouavi2+vfa8mCeO4hshbWIs7stbTdRatt2zKPrta+2NXmcHxG2m/S9hgxo8REaWM71ubKHSUtxXRLX7v8Gbj2eWnLz9IWa63XSrmsoqkgHreg40b6ZqVVjFzdyFjfZvTa3Pfv8h9XSlo3abtWVJwWI/bY8HkqJzU8L6Oo/JTLIahHyW/Vjaxr9WZpa9Uz9iyaOVmPM317zejP1lQQ39k9Dw39oX/07leas+fSWmJr3ZN3rea4V7a92e4QH9la7+XeQLTcUdS2a2Mdxdp+nHUze9MeC9K5LG2/k9XnojmmvB8X8Rg3Ut0qeaymqSDWHGzt2HVRvn0lz8dj3+PTEn3bffW2eAbPCkh9pO01uXMm91zLGK20hZq8zT4LdQ91w5X4rpjSVH+25+P7Rh1B94bx6dbdf2+r5zdTU0GMuUoXI+vzkUaebCPmg3Z33k/a3D3HvTb2nr6PvqUkLpLG2NH8XruvsXQrcB15/8zdSu1vott/e/YeXhwBdc0Fcd9dqd99njw8fVZSWh39qmnp7wzErmn8TDBe5F7cdl9RE7fqtUi1bZePoNx8t9lW1NY6wozltczS0vbOWuZp7Wttj7rmgriXGSf33YwoSttj+SOcX1D9kdYw/uI1fsSP/b4qPZ5D/+auJNe+x19gbIto611r7d22vvL50XLmSH1bt/dmGX/c/rdk9ePcyxcFTxFSEPc7KfpF/ug/wrcYv1IzLl49CpuPfpF/2MZoX+GWYrfe3hrtzdOrfRV8ruMen4nOy7M20bbMo9ny6xy9+v29dl/nyu9baY/3uB608P5kZFUj//LgXYUUxH3pTwR9yzuSXj5LdK1m0u639WeCD82+0rTxKR9R+bu7uueiecbwXgWOPCPr1aK/+g49iLTm0vaUdG3Wd/dZ3Dn/O+e+qrCCuO91rm/0uxq/Kt4Rt91Xv9b+32WN1ShdlDXZSXfjW7aWtLyIRP9atnlaVuHNO0dvv560+3DLPMpZcY53UD8qr/c3y9+3H98z3DPr7xJWEPdwvLBsl2dy5BZXnj730W92pcj9RrQYkYVlDEtbjbjL5z6zlsejecb29FmJlL+0fQTxyDwlqS1Iy2ytvcYXXPI4cosPqWX/NZQyOLO2P5MK6JpaW++2ur7rz8cldEIL4r679GPMKIjWvt+ecUrL6yS3sNmv6/GxVALE7ZHoOaVUu/+87b6et1yfjcjNE8PTJ6c2o9oYx236bPQty+KOrBLpfqRfS9/VvUL27tp67b9ecREntCAeJ/6kjI8Ypy236NOwLRs73Yv3k0Tv0X5aM23Z461j12mLaRSMWqriOD8b+h4pOW0j7t+ojlrGPu6XfdueK3mZ7+DaWkMrvCAed4hL93++h/VkifZt63l3lv2xbxv1eAb7+LYettZ6+cI5Ri7O3CtFb7qVO7aS+1xbtKxiS1+dfb79R/NbKbcRufjG8PWymF0/3El4QZyS5hIUZdxIM603S29G3n5vnNZ5bat6Z3Ezzx1b2ujadjURMVLqXyTX8jRvq3To+UZCozxW5Gr+6BO13ay8zuO2fp+jaRMlP5YvA18vaHQpiCPJF8Et20rud+XpM8KIE8A791I/6/MeI9ZlFss61S62c9dIMwtNG1lrFG3/WR+L0I46d3+X2fLSzlb5BmCzRHyz5Wtvf2bJr3WsMSwzusecYnOMjYYY3Qpi2+kQYfyI8PDvp3NPf6T1WS6XtXW44xodc46Zge0tc/uY7RH28j/0bLmr7WU5Lvd657XXPpb9bY+1fYvyWN69E2Pu6B9zsqiNet02Lkc+LmHTrSCeo/2y1B4h2qoH9HordXWHHPP6Zz7iuBoxRk3/VbSwl1kf/p55/v0Sm0cKDFgPZJ2xtf2br9f95NfasitbVqqlr6Rn7Hf0viOgTdeC2HKCxNkyj7AW3565/6XEN++r+kpEjXJX0vw926U+Xtq42mNfd9e4XmBrc/qILtd9hHPCmGK/YyCfp/4uoueen72Hxjlqn1HkuCPysN0BztG1ksREQUnXgjiK/UJk7+HXfoiOzNar/Z5Ai2339ZmePPez41pcV0Y6I1u3f+SLpj57Slug9Rm9rlai1X8b9PZ5EMAexLqvtMdFTkvfbzBz/vPHnpOB563T03UviG2XnEhbsl/y3jx9Wow8bHvMrRSzx1jfxLI+I4+Ru5PWtXV7b7nxc/t/lWPCd5Wdb+T6SSskbd+ztG3Vfyz7G9rR2vJp642xuhfE8/U/pfvhZNp78mrc8yhuz3rbfb2r9uzzR76/cLbfO2qfg6D7AOkyhnXIVY7F/L6z7lGdtqj91+qcnzbfV+aRR723Lraulb4d/IYUxBGnRUuMu97BGM23Sr5eHuNGWh9roVVbqbX+eecP7Qtfrl0+X/mZ76af75Z5VKNrJdPu87uwfFRA1+rN0lYnag+exWeK/oYUxN/rfdD3OqWAVe2P+ZnHv3TXbn5uMXSFrv4OcYT6Ww3HNtWCqRq5We8c6lrp280V/dYp39uyFpa21tZv1j0ueSXb24E+7D8DQkoDC+K2E6uN5+CYmW+EsfmPHe1bvVdRd6xG/KiuTj9CxGheM8eW1HJzFYwK2sI5Qm1+3m3RuV7iqQfQNdS10rfTiIwlKe8rfxaWnpa21tater3RxDzDCmKUtZzGLX3v5Tkz1Zi/GpEXf81s8m00PbWkWNZiU4rXg+4O8bq0uWqPhly8Y6vadz7lGDHlpXaNfliil3nf5Jyt0FZLH1PfEusaWhDHnJbfJ38q6U4wXav+7PvW3uNpLCtkaeu1H2P/Odrj8/clnUvS9hW0rH9kwe/e9tvG+kzkQrf83KtlkYZY50i707k9L7919ldKKXl+Io63oQXx3dgvyT7zTmSbep53mQUkd3oR3JNylbbPVb+etNz51RaKq4rJP/8GzqcUwR9Zuy9TKo0ijS1t/9C2O7L06tXWxzfCK/MI9ze8IPYdft9tpVOK/bO6iKNFX3xpRrO29/K/IdNtk459aXtPMUXhTQROLOJ4DEynaMQYWivlYnfMXn4j6T1CXsnf127cSM82vCD28h4Q/PgAkO1fRkqPSzRtosWN6b0+lDOIy+2H/MJuEx1vVcV9cdpgveva8gZF226e9TPUkveTfa4r1xQr53YHtymIZ7GfLhH6HtRz5nRP57X61rXre8RF+Vl9W7621hre46DWzxoz1z73o1zt7OvxBqsuhnWlZNZ5at9QLLWmHdZtdfPWWmf1/J5mSkF8/9OSw3iGGat+HrM1h5Zj39t330/z2Gq/Ji1xLKRxWrevRpvvVn2Ua1enbacRGSuaNbd5a3rsXftOUj//bbH68+Xj69Wu9XUCc0wpiIE32+Wqx784KEU8b2/9PpI29v7iXHrcQptHX7bZ2Fpfae8GztM6w3hjMjLshe3yoCPt7LXt2o0b6Xto1kzTJqX4dmhHQQxM1PJSnL9Q1i+f9btCseLj618a9C19cnPrPeYqavs1dFv8AWQya3jvuJp+pV+XOFP8jY6feNqPtnwDPj/c7hYFsXc3Rx0graerrX9MzuPdNe+z4zxiZ3U9IltG0x5X2nbRbLOJJc1Z2u7J3lzwNdJe33St9GrxvNtWdLd890a+8R3JOpdc++tz1qhl2mMmuh1i3KIgXkv8IRp3Op7F5/o00fsmOl7JmHHGjJLTemTL/cfNzVtI1++s1e4E6vqNlNsf229fomSCVeJrh9YVXfp4stb9p2mzInve8nnuYc+jN+2bY9RNK4jXO6Tm4VAe55uPu9i5tUdrj9DPO7fymbdy7ndlLePWuC4eM6u9zfCQokjbNXqtY+0NmWWdeuVXkhtP+1yNtn18O21LSKYVxMCa5At4pLGjjaW/UGvaadroWaJ98z7yuK6H7oMSulY/6ndZ6yVX3D4rZW05grSuMb2j7Pvl1yJuhVqtkMkKOWA+CmKlMSeM9/I32zp32s7jxf+FjZnWPz6OGY5ae/u66DK7tsrdL6y1qo2Ti5X/rq/IglI/X/22/cZcea29u1ccY6tt7f18na+Xv99zta2Y9goU307bEhq3KIg9h2qfA2Wdwk9nflY99sI64mc3Zo/1G2Ufud8oFvI+Kucp3bF7FVr1Fb2uo/KXVlOzNfdWQ1vQa4vk6PXVksb92S7tMSnSeJaMLG3LYqJEkvbah7Yd4t2iIF7HeidZzT2ytWZ5bH/uzcVEY8wqjRmlJ+nY3FStRtAWdtrnclp/2nLtXY/XNpqO9u7yCPpxW/fEirTlfp+Za9Ze02akPjf9no2CGCFmnZrncftcLu9EswKaNu3iRpl1dF1p56RtF2XECmlegOUWe1LrLftQQ4p8YYzfgz4F8+y+ln7N+tHsDU2blCzttC1hMbUgXuFgXkevA7z3Kr/z7j3KU/Q6Cnza9up+Lm2R3vJrE7tiEXlKamNEjh+7MjqR+bfMIDaPteXnet8VuG/medqjWNsO/UwtiO9prdN1lWwsJ/MqOedZZhJv7bWx2c9l9Kq+dl+/hbWQjj6WND+oj11xebw8fYkY/Zxf7Mo9Ra9Vi4obFWePu8P93KYgjr342EmHoLQd8Jh93K/EshaWtl4jxuinVjTmt2leiGPX5DRebPAutIWzNBVpO97q63SfVZTPrDfNOQi/2xTEq1v71Fsru8hTeq2Z9bbibHU56VrVRR43GrXiMCV7PhFrMJPmDrFVfERJZa+OT0Zl0bQuynlqZxDdrj/rNSAnIgZiUBC7XE/IloN6ndPbyjfr63z9K+DL4Ntp1lPTRkO3B3Stcvw9c8XPcdb1NWgZOacWr5ZJ/V8Eqz8sndUAACAASURBVPesiToCWtTXeMs8ihG9b8fRrphOqf12+bp//rtojgVNmzNPnxruDvc3vSD+xhPMZ+xKjB3tKPK0njkPm8hZr0S3B3StrlZeNeucau17z9Oa6yi5vKq5rjqRBqtMaWQelrEsbe9Ge95TDI8xvSDupceP92ZpmUm/eyx+7Zm0R1iP7oI3fua9z6TYO16RRt4Zs8avtc9t0x1ddeNflF+ZRz+sa7aqyHWtr9jVvtX1sS7Gh6V1r7YjrZoX/L62IH6Su70wRL64zbgonXOVvtfR9jq20/byi3m5joiRL1Clgr28NWbtSvujFD1mVKuIUaWVvmrd6/JqnuXaaZ+bp56NtchFmWYFNW0iaMeJuQJD41YFsfUiZr+AW/SI3SNmL/c5Sc/HQb2AvR41K++V/nuhdfbb7uta9Gs3J/vaqPrcxxqS13Z5UHXMSbj3qQs5lD0lzV6ot7GPGUeT/Yfcds5MpLyk7ZjjVgXxLBy865pzubOZk6Nm1HKb/ZbS4xhSRGn7Ud9cc9quDt4cc/28sSKNzaFt7VchrZlQwnexvysZMXJEjFlyuY+aD3eHx6IgfhTp0ns/d7xcRO6FyFh7+3UtPfYaX7TmbZevHnJPuYVeZCwtzZi1Npr+PrrIx1a6Pr14Rvf0+VYR15/ZtHOgGB5viYLYcsJb2qaU0l0+NrFlHuW3x+kRc2/E6dx7DmNpZ6NtZ1OK2me0K3+hLLeWW6wjMlft9a/WqvU8bu2fJU5LbDCF526jtP3I1lqj90rGZ6zXY+weMTHGEgUx2nnu0PhPXF3P3hfSlLSZWMRHlPRbJzlyqWA6Ptv6dq1t+yaOH0saQ9quERHjQ1v0flhXU9eqLNc/+rmr0nmsOL91A4SRh1PkbGKLV28tZz+LbZZr4e7wHBTES4q9yBxPLfnlMGp02yntG9XXCx/Wj0No2oyy3/elx6VnbNtl7RHqrEVvJM0+r7XR3hVteW5FueOwx158ZR61iYozV4+1HoFieJ5bFsTWA73lMvQNh6Z/9k80e7Vmj1+nKULnzEA/qr6l5u1jpBFj2LVmpe2fa1d9brdRO8aHtf1cc7P1jG59g1RiadvOM1N8k1sWxGvhJIpxvfR908pa3pTpWupa5YwsZDVjbZdncqTt6ylnnN8SOcPIWD3o9vm9Xa9ofe792VbRnoG9hzWnH56xPs597bH67B+b+Rk82TIFsfcE0rIUJGvomW9LbP0J2zJKC8245zaaPhbR8fyumVg/JqEjzVjaPk7cnOtGjbOCWokfvQ7R8T6ij9BrvNqrkGfL22v3tQdp/FmsM5bbrzDT9zHy+R9jLVMQ4znucKJLBfP5DtecOflG3fc6z6NM06bdNbfr47vo/SbcGt3aPkr0uLl4crEjO8QwJm1sfisRa1tiiW1p+y0ojse6bUG81gEiZyO3yLU5PiPFkLbnePrEu+ulrlfetv3+PaSZXst3qUeOp09K+QJX/4biTd/ybbX2Z9b5r6vXuWzTdyV9c+yZkz+2paelrY7vXr9WPsJ2+h/xlimIfaeqTe87NvfiWwvWMEavVSwViyPGKz2/7R6NyGlPGmPLPLKwXres7XsbkU9ujJbncht9e++oJUbUOvri1Hv5Yv7w9Nf20bZLqW3/fCOK43jLFMRYy7edZH3m0ydqi/0LjOXFxqJcBNvWIzq/+vi23HJyf+XGGtXavrcR+eTGaHlOy9q35Xi0jjWLbo7ts7lGaI+JMorjGEsUxLqT9Kr3zvfmFStmljFRyvzxf1ZZE2PLPHqa48zL69BrraKK7n1W+lyl7X5SZGn7h7bdh7UQzLevHQfWaNKWkWZn4XkTJLdIyb7fS6Q3ovnzTM/T56rlSvHWHuFIGy9m/j908XStcrbT/9BboiAeSbp47Olb2to+SWldcs9rL1Bn3rU/97N+fya17/u5s1aaF9X91/3zFnIPTXw5ypWnzyzWc2H0L4zSrOX1aCm3MlNMV9Hk4JLJln12knIeunnqWuX4e+5p1jFmJBxtu/9RN70gHn8KjB+x3ZZ5FCE2Wqu1spH1zNfyxm3P1+se9nPznMVSH2n7GLoyslUt/pgM7uJ6VEQdJ1Fxcnuq9FOcqDGPOFasZq3YdvofR9MLYsTyHOSePjH6XJ6fxls8r0uaT58Z94hZLi9j5xAZTXNWatrMFrEi5d8s0i4qTk4ptmdMuc8djob1yOsqt2hFcXz0sILYfuJaDhSprbQ9JV2bGvsM7SJffHtZP8O4HHU/LrePZu+Rkq6Xpk08eVS5xUyjzjvNKJo23WgO9wgv7bkVxbeqcoZyi6ufXOTevrxTaunZx6hz7GPsaHUUxpMLYvlEizR2tHi6Q1XXaq/cwxrL2l6jR0wcbbtHvdZ7H9f6+Kr9XJbmKW2/g1lzmDVuD1Fz2TKPPHK95YhyixpPb/sZKvc45iG3723tvxMCj6kF8V18y8E9ax75cedf0DzOc+lXQh6NGWUltRLi+Ezuu/x6rb+K1gwj21tjldzzzD75bRL2FfOso6/QtfPsG0+fHrm3ka4i89TzWCXLZ5hWEHtOMr/jaD0PMSm2tF3DG2Psmq9Hs27nckrTZ+9aMJ+/t0aU9YhZph9L37JN63E9Ks8V1NZKs46aY61r6aFJstVhDPuA9h6+Pke6Nda16qF9ht9s3n7B3rSCeJyYE3GNA7Yti3Lvtrhe3lG9/VY3cl6RY+1jnd9QlGnaXOV6SZGk7dAb+5naePZjod7DHq8X3X7RtTpaZ473Yl03a3vEm1IQe05KfJN1joAnXYQ0d/c89nuz9PjKdwx4enn6jKHbH7pWP2rtvds++hxDUkxp+1nDHr90rd9Tz221ZpuSr8+RLoKu1ce7dcNqKllHsLZvZ1u3H95+RzFRIJtSEI9TPnHue4j1ybwUtfx8fkuf7J6pT/ERb59l6fGVb26+XqsqXZ/uOMsBR2tzHSQEyG7eMo9+ninP2bNF4u/ZInrUWrzosTyic7DEs7RFvOEFcfM1TS1+pKiDVYojbe8hfrWOtHPStjvz9suJjCUZOZaO5oV8QPGTpFH0GehbjpErsaw5WtuvYnbe+evcq3IBfGUelZ/R8PWapz3fY4T2eG8Rx1JEjGgr5vQUwwviJxhxQMeUCj/GlDgpxV0Oj/pEXdeovbVnW2Nfhvtens+r+kYdK1diWWdq/VF967q09v+wzjNafh5Rs1vf7PVPqd9qS3Gl7T1Zx762t0aAx9CCeNzJOG6kOTg5znquyDn29fvjM9b2d2HLuv0crI/ni7/q2ueyiixwfasVz5r3b3pO4HUNbt0fFvU4UaP82C5fLeLPmD73i6+i8261Wj64GloQj9HvBEuJg3oG75p7+820Ws7+fPQ9Sy3rZ3JkuThfbq7WK5m1/Zuv155utXWthnu1ZCb3zLeQ+61Ee4RoZ6Vtl6fNJl7+TZJtNpbWlraIMawgHnMY20bpecBJsVu3a1rklHvZ1s7DlzFaeNbcepHvRcpjjSzr8i+i/udGs+Vga63W+dLUOfyF56NAOn3WX45am0+vufYlz3mMYx6rZPW9hhXE34TD8o623VcNfctR1svIZp//iLmMGGNv9HhntfHL26S3HV/s11ot6i9vao1e8daStLV/i/NKta5cjzee1v6928NvSEE85oQaM8p3esLalec4+4Ize/xRWo4yaY2k7SNoP/agfS5ndDF1R6oV0i54gbawahwmxD4vTz79jjlPNke9MrOy5mFtjzGGFMT9tZ9YVpoDWmrTvl1qYVOKln/+ZWw/my2rbff1+AiS/VqVHpeeuTNtkaR9bozx106Tanr5jfYZ2X/k/6ps24vfr/WI0njS9jx5nqvwzU8vH//8aqFjac8r0Ri3L4g5PFrNvdh595+3X5Tz+NJvmljdMd+2Y0LfW9/ym2jvEGtXZ9axZhlXbiu3CHNZ2NrY+hLoGFZbMsfqMV49pv3NxEgDj6ruvmkuq7p9Qdx6yrUcZC19MVrrkdJGKqAjaSNr21np4+pb3kF0UatdHe0YMyz3NtGxWNqsc3PV9j3y9eplrWzaac+10rztb5/Kerf3GDHGqm5fEL+tuwv7Z5Yfof+4PppCUG6RV+/XJ+qRpe09bbtH+9muPvMR+WlfVKNziY6npaktc3dN1U7NR8zzOkb+d0Lk7v+ucIdYWiN7PvYeOj9xzzlL36/Omq+1vacHdL6kIJ6n9dBs6d9+qWqPAB/tymveQPRQGlWbd0/Sisjbt2I7qW/NrLXxjtsy15RK/Y/P1r6rybX0zvM3xQK7Fjl/BuaOIO9cY9XGjb6alP8eyZm2nUZkrLwt82gdK+b0Lb6oIH7eYeKdsbffj/K7e+n50dZ4kbqKziT6pW5vH3lfRDQXKF3FrYc2krZdtNrLt5yT3KK3XAYtx1a5gC3ZH9VXLXeIy+ave4TyLG2r0WLGSkpnmjUna/t3j8//iDKkIB63y+wjRZyo9lF/RIzvYxu5ZY6rsc/F3uP79SvBe8WFXm0f9NvzPzbb5emgoatRfZVK2vMbsP4ppYhMZzivjna1tO3Wc9/MVzOkIP5278vGzINy5tjtNNlr2qxh7UxrxYwt8/YXy/14trF/ePvhfnL7WvtcbsMr8+jKu62s5zHry+hKjmN71bu20/bswzJ6qa0UQ9p+Zm1/tKXWCPjKgnjsQSFfONCL705Vvo/mhbX1ey1vP52oI7ZvllHukeUz1Yok20cXZL+1yx4QtaPEu62VL7av15U2jnb970I7by1rPGv7KwrjFl9YEKc074AYO+6ci9GcUXN6f4r1GH3svh3FPyvf2vvH89FmuVUfXY2eR84KObQo7ptXfm4t86339d4F1h5dR75eVy3rIdNl2TeHmY4zK81z3fmvm9nKvrQgnmncgag7ZUvy7a1RPHx3dq+i4pT4o/t7WmhH0bZ7070Qfuxjr/iiMXJs28r15S3mo9arHEf3hkPLFcPVKScs0M3MPNLj1jz+ehXzmmptX7alyGhP8MUFcf8DYeZl4dtp9p7/DrEmOkrFrmb1tt3XFvUI7fEj2bOx99jzHv16bfktbTc17Ucxrs/5r0AR5o19x+OifbVaZt3Stx2FsdYXF8Qp9TwI6qdXv3H32k/xe+t9h/gqerwt86i/2lgj89CoH+O2M2C1uVnzP+s/nwkfGmpYklp+tbC5frrnxl+B9qSx89ulXik17YTfaNZGbnEH95nFfTKdZVhBPG9XlEeOOO3L3uO2jGHva11lW/tSa+vzOZa2M83Oc/b4o9Xne9x6v7WplSy1ubXNNP5TsT/aMusnm1cl2dXuEOeK8bK+e6Fv9LEiXru0esS029IqmaxoWEH8TSwXwZZDr6Xv3WjWNHY9YqJZoljatho5Vht9pvqWMt+/Vlf7V8s88kf9K7Ot9p3Olnk0R8T4ETFSSiltvtWsiYv3M0tPTGsf7Zpq42rbjaCd25H+bYgv/kwUxjkPKYhn7fhZ497PfVbKn+n8F4h8BvYZaWeiaadpY2efk59/BrUsj9tq30UaNc5Komepj6dvOYL/OM5ba3aj1Ge93pqsl9FMDymIU4ra8daLhv5fe7+yjgWU+I/CHG00uZ3mk4YflvPB0raVfgb9rZRLSW3f5PKX5iRtT0n4mIgmgIH+2HtlHkEWu8NK0azPa7X2j7elFbOa4UEF8dH3XoCsB7a1fQxNISS3uPL0+Rbj5q49e+R2lk9hjpvflXVsa/u9lr41veJaReehOYKix9SRRpW2z7JqXmu7/6pRGN+6INZcCI+2zKMRxo72Lez716rnfrnG9o6mefMQo/+Kn+3nFjnLyFgeuZXU5pTr23vPaHObLZdne+5bRJDl9JrStvtaV27T56xHjOfuk6EF8RrL/M7C8wJj7XNsv8bsR2uZdUvfFVmPn55qa7vf1vvx3uz1sR5v2jWs0RZ42niWlpGOo+Zz6JWZ5ript/l1qzlBcwe3ESONGONDs89WUFqT+vMjV7KPcTdh1jK0IL4z6wlsbR/rmQfz6kbvFct4lra9xOdgi2g9Z63t12Vbp5zWtWh5E3BtV3rGWt7ktc41R8rAM6a1j7U9vpt0TH6jhxbEs3b1rHG/1+x3srNfRCyzt7RdR/vdRm1bbbsPa/tZRuQ5YoyS6znYcFaeJtLy0ZfZZuSpHVPbTuscr+UNFlL6HPlPW7OHFsQ21strvf3PIWaNiyvLX8q6k6ddiM4s87e01dkyjyT1e5C91cadfYbUcmtbr9Kat0Xdd89Fmr2e62hc50Caj8SM2m9zrwTxvmcmsscWxLPvLKb0rAMt57wPPOvRvh9t/Vsuqi19tcqz0YxuWwuZP54m2w9LW39GkrEvume1cb0F6Xb687hthZf90pprnrnKtdH0W1U5d81e07TxrXNK+nZeI+7sy/G23f/3dv8Z6Dy2IJ7rfXj1vSg85RC+u6j9JB1NUeOkFBsrTz9C+1uiK2ktc8oFYnR+1jFqs/FuG81WlGueuTq00XQI1GOt+09BM0K+zfFZTRybmIiRe2U7/X8/98zahoJYwXIg6E8hS9TeVsqlzpOpp08E3bGQb+W94/eNIueru3PkH3HEXcYRY0TwrqK2X/c5axPBdPfbVSsXyG0/W7iz4QXxSgva495SfESv7i8XWIr9yNPcuymLbKdpoyMVt7mRcj/4rWVk3dbynJY1p9ZtrSJiR8Tw6DFuj5gzXgF6zCMnepzoeHbb7v+1rZ+h3/CCGOPoD9wZl0686fZS7c3brKImztzjL1dEz83oR3Th/E1m7aMe4/aIOcOYeVz/KrX0/b1sp//Xs2ZW7SiIv9K9Lwet7CervUeOb9Xzvc4Z+WLfRcz6n7VEbel7FRttdZGzbX2zF9Wm1Yzzt2VetXxnzOXsPDfp+3tbs0BeJ5M4UwrilRZS+7EJXas3S9saKU5++wqXqzjSGtzVz17aTt/nxayDNsqsdiVb5lFf0v44G5WXxTUn3TquOJcczT6KarPnWR9Pn1bWed3JyLnN2Hd12qqlv1XyiDKlIEZKY09pRIj8sdx339G4i/KqW/eH/1iwjqSX+2x0eVuuVbxZhbhmTpo2Kenb7Xn6zKfZI5o2dtL10Tuqt9+K+szFfqT2yWMOCuKvcj2Yv+lgHc1+aVjfNx0PuvudcazFnPa5J5g978jxPbE8fdpIdxFHZqQZ69jmG6+9sbbd1/m2tE4uLaYVxCstnnTp+NC1uodV5jLrH+ew91hLPn/NRVI78+h23yJ+vuXCuXZuyPv6um3LPIoTGTMyVkqxBZYnlqePrLZK0r/h2Sej9aw3z+iMos+VFivl4jGtIG4VfVCN9c5ec/BIbX62z10R2wszjrQrpG2HfuadZ8eRX5nnYnjPZW8uuZjeWCXPO3OkGUvb+zrv33M2c7Oby3Psr7ReK+VidduCGIjV4zRui9nW+0dUnLL+I6xj3lxzI2ufG8E6rrV9iaaA0LS5G+kecBTv580t2Vna9lI6HlfILe+Y8XZ5Zp5V8rCaWhC3LFpL3xztj911rfTtYsSesmNzt/Pk5+kzWkuOW+bRd6nPS5p1r8IxIka01qtBVJEjycbqvKAR+XtS9PRpEzHTtx65n2P2GMPKumLW9qP41zJ2Rv485plaEH+z8qEVe9BplA7M9/Pj87G644mV0/oiYG1fpo2kbbe6sfMYO9pVeXzduV7LP3JuxVi7DbqM3yxttSLne9Z6h7d+E6ct8y3zKFLbzCHps9fsVslDa3pBfLcF0xo3r/o/Mxtv7GgrOb9ISAWubaVsraPsR52TwUfc6HGRfLQv9rPzvAPLGmna9ish63LHhPankjO8do+0x7NFfubrrscdrbKaq+ShMb0gbhG90NoLlK7VCD0uVd/Bs4/aCtpRzmW51KpufwT1PZq0GXnFxM9FsUZuiaHtq4135Ou1F3mMVGO1p5oVmb8c7Wd7fjpS/7o+peqZ5lVRbqFrg5SsK1VvbYvVzyp5SG5dEAMfmsv2mb2Hx5hRjiLH1MXar7+ux5pyJUavskMe66Vsp9e6b6zFuXfbp4Flnpa2Wj1ifvSM3UrcNxkrz+duPOtfsiVNPPZeShTEg/kOuoi7C/IJcWRt3yLidxGPF5PleebnqDGj5Gy7r3r79pq+pfaavjOMzEsuLsv7SPvcUf2eotw/z3Yl+uHt18sln5cvQ+86rsTzk6Nx8x430kzRs4yOZzV7fI0lCuKVFspzp7E37QXJwzpbXxnl6VEXHW+W877tua9zrONZ29/XlnmU27p/LvqotK22rfVVa38r1WqpGh1556Hdzx6enMZ8JEKmXYOYbLWjwWP26s4eX7JEQdxi9QXuI+bSExdHNm6kshHHynmM8xuI/Pby973txyuP3TcrTQ6lNn0zs5ldwGjWQtPGyhtTvVqboW3y5/M8s874USxHzZp0+0HX6sPW+lmWKYi/fyf5T07N2mja9FbLYYX8ehg9r3OB3cr6o9G2kW29ba3Hyq/VNePcHFad18rn7+zx4+WPIM05OIL1urCm1qOmtX+MHln0iKk1c2zJMgUx7mbsYe0ZzdPn7BwjIuYYmkyPP+TXPD7TtotRHyH+Iwtl2kI3V0zMKDB6rsyI+bwME7DnY+/xod3nNdb2oxmWXhAXCe229Nkjqx+B41AQ347/4C1djmZfpnIz8uTkKYjWK3j9GWh7atsd2XrZWn/4eq1MWzj35r9qvNX6D5vPZpuHpa1Gr3n2ittixZysvmEOHz3n4nndbDV+RJ2vKIhXXdwf0Zdm3E/5KF2vKM8dsfc8huWCdFO2023x0o6vfc7DW/TW+mmOGk2bD8tctWuljWnJ8y72c2873jVtxvq2/VVf4bb1n1EUr2ipgphdMpJ8uZD3h9xCo1yS1Nl7+PpEk3I475l8eymKljbOlnmkY22/spaCKoL3IxiaHL1FryZ2jaW/5aMTOd71Kyn3zW/Rj2951m8fLzr2bI2HyuOMLorHjqazVEEMybddst68s/L26+18oltP/LgLkz+Ov2dd3NzW1muWswrynmO8fvtz1TPaJ2o2UXEkPffxPN81q96zGX19HjuabLmCeLUFajfqcqYTsb4RMSJo8tC0kUTEWO04mGVf9MSsa15MbE+UUp/SS030cWGP55nlnn3Eo+23P5WZbLoxNW0sjtm1RLf1Va4KbqJ1f7b2l6jPwy+0XEHsddddGJl3ZKwVrTK/cx6r5OXXNgNL733bfFlgiVZ2jZ2/zI94bqxjBiPyaR3DdYfYNaghfkZb7yNLLEvbPuZngKP84e86KbJGFsXjRpJ9TUH8/SIvSrlywcvfc1XfNaNt99VP219ut2Ue6R6XnsnRtWqRH6F8lprKvQaxo/Rfx35yx06vNzHWVa+PqTlWXplH9jz22uLYe0SL2I9RVsoFehTEXc2/SNxL+2VE88723ELusarIzCNj1cjnRNsLs00uvu45TdGyVyrGdCW/9rlotjm20Zy7B5s1P1trC2PmAttKWNo+03orFJFRRIwa21HYZtxIdRTEHcUeUJGx5ugxgx4xIdOse76N3HPfotRajqKz7b4en8u1Oz6ja9ePpryrtdHk+mlTi/M6/VlrU2N9i5FSStummYWDMZVjc7lzvYVnJTw0oxxzyffQxEEPuetSpNgapm7cSGVLFsTehfH2Q5luTXWtnqzXhaVP1LfI2LZYtlLaFnu8Xvlp4tbaaMoYTZsPTT7RXi9LhkqvOXOxkIvUu7rPbFY/RqL0eu1a0S/d3mFDJfL0j4zlteLRNCOnGWPeg+Yo1bTRm30nN2f2+Efl9d5Of9ZE7TV1HHVDA0VMRZMDbXttu1XY87X3yGuLozmWI0jjSNu1ouLUjCqKx4xS9ktKKW3b1u9HTw8XeyBFxkKkeXumPPKWeSSptfRuOzqeEfl++miR8oXz9Vm5wC7lX59X5Kw1sWL25yS/1kT5PNsKppSkCC3xj319kXy9jjQx6m02RZvZ2o/j9ggjjMgytpZZ0+EjE5/CmAIZEl2ZcKS7dMpxJD1O3HPE8/fnuV2/180+0vgR3+qrH1EQlMXveb9+udx31ULOAzGEZT6v7MNt9/WqHF9MTVSOYItta+3Rf4Q6y162tr6jLfMoWo/X1rP+I5RVP0M8s0D2jubttzdip8/0bfPrMRtrTKlgPq+5tb2HNkKtnXfbx7VNfR3uJSr7cpz8FnlcW7Fia92i6bh+pUuq+cwt8/k1H0uXCuvsrO1hE7Rbi6T917p9RU3n8OJMf6luZoG8GsvsaweQJc6bvccqVs585dxirD/DWRluu6/H53Lt5OdqbO295XC9jXfbaIdiplDZtOf7ysb2FlLefmNpsoxqM1f78ZFSVJQRRmXasyieeVSZCuKzJxfII3fadaw+a90n6hrOc/vmubaKLJi858n+gmsd08qbo0fvsXqvVSvXRyaMXbRvXLaUzLFltoC21nq94q5h9aMcd9VUEJ+dC+TWItnb29vv6dovovWVt8Tv1RZvfc6Ra1T/OK/Mo56Oo+TG1D5X41+PPeuo67DcWfopWEvz7bcO+iz1PNle++iilPPX9I9qs5r6XvVulY6V1u1W0fFKLOfyXYQWxDmtRfGqrLOK/dgEMFr7C6DtOM/fIbbFuCrfPTxuyX1X7tvGHiPyjcdYljvE3l8xnH/jkiktK/GdQ6f6npCiStvb7UfoP9re2NEi3eXc2htTrN53n5Z0L4i7/OJ0pB6naSli/EiS9hFHXBBGjBGplq13m0X0lUDKS9reS0ThbG2vWdve+1gTQ33OvPz5qtb/twVT5jOQZl9Ge+0ezRg/ynp781vd+Sgp614Qt/Ie4N5+0MuvMSt/R7XL25xLn23U9qPONp5MfnvZnvMaLPMQy61X+m1XdDsmTZ0ts/MzpVRQKmpLsfczKz3Os2ZrbZ93zEvOMp5/TH9PH/E8a9Iz9lxdC+JvvztsPci9H5vw9bIr7S3r87ifrbI3o46yUaWg6g7h5blN2e783KhZ9Y/v9br86bwyOLtpwYzsHwAAIABJREFUvC4PWsXujYho1hilojlsiYKtmlcE676b55v3QseC+NuLYeBe1jof7/MCsI7aHvS9oe67H0x3eDONrXlb2483LouokVa6asTMqTVKa3+srEtBHF0McwjWvFcnYsVL62x9frSoPKz/eMaZtD3K+i/8+OizP65nu3z+yy2ibKc/a21SSr+m1p6fGEFsYGMq+IVtwakV4kmj1Le/FG2uLO0tbVHi/gmN6Bq3z/VtnvCCOLoYbjFiZ1nHUP+lkhtbdY7WAndVljOsNmd1waK07b5+g9xMZs5uyzwqP2Nv0coywuvyoKTUwPh8dRxL5j/KvepXwPw2cSGS9EZIE+GJfHv36BgjIuJVn6hRnnF0hRbEKxXDd2S/iOq23lF7UV1/8biz1pWx67ty4+ej03fWef3Wot9sPDlvKRVT0l0HDaP2m3pRbcjIdAyrINBkpWkzUtzsUbPafu8nrCCmGAbGOJ5pmvNO06ZO89LTPopuHIvou7wRc6zpHT9OQ6av5P4dwK/Mo4/sfm1IMyV/d11R/+28q6f3nLXUif+4RHS8tYUVxL15D3xvPwvrGPG/bcKewwx3yPEOzuvYvq7vi14tTs/LYin2Ph/rYytt4Zx/7vqs91y1zkEfq/adzfbrV1eMngdSlSvb3+Za22rVugT7/tdYrdGfoHzs6vdo3Pm0rucdSyEFMXeHcfSc48H75ibSiNXWFKHe4tTSdqQR69pKdzc1hn4/VVrqg5hd5hu9AAYTh+5k/Iw6HipAVnNBPLIYHnmCjByr3bh9MNu99ssYLWuiv8MYrW/0CPoM+55/3n2kz1/ndfqzhTdv9baIJJM/jDpPh9b+Y3hXzmrcalxHso1ta20X+3GJyFj30VQQjyyGx7LPy3qwO3/giBsbtc/Po0jfy+w9VhS9/rHR7qN53pvnCmsQGLx5rhmtbyx8/Ub+LCHGalm15tPaf5z7ZBrNXRDfqRjucVFb0VPm2VPr7yLuZdS4MePU/t27MfLzuGaVa6d97l5m75EPeSWbSjexQYmcl4UmjfqVZiWa2bSJvLupW0ldq718D30cfcuZ4vbDHbkK4jsVw3d0jxMnTo/5eo/Q1guzZS6WtnmaXDVt4u3n1j7P+8mtem0datu8BeJx2+p7Ycs8qrVam/2nEfXzdNRZHDPONcr5mZhx8NH6uvUWEePezAXx7GLYeplpMXIsv7n7Y1XefeftN9pd8lzJGiWHnbVA3E5/ynQj6OMpVIKtuSdss9cUKJY3LLbRbeafFy1jyMW3lX2t7T1K4iLBw1wQ39WIA802RutpuzbbWkTTvBzleftFmLtm32/k+ubGijy2vHeUPWtQ7uOJZjVijBZj8tMdO7pWZ/sZ7B/7or1Z+ubatjwHD/9KjjkDxjAVxLPvDo+x9hxXO/h65mP/seOHv+dd+ef7aujbZta4I/S+ivSOv9djrO23LzY9clnVjLl6x3xlHpXILbTiIt2Z//YPztQF8UrFsOM6upiotbzGWWVtombo471E+Hqt8LuIz97j/sznnMfcvL5J/pjJzdM6d2v7t/g3g9HxWmyZRz35rggxes5wX8CW5+jZclVva4l0pL1j7B/har0rPSKpCuKViuGU/Ae455D19Hm2994prdtK6+k9jlpY5m9pi3GO+0W/l167rxq1lvpR/XqOoV+FI7FfcNK1cGIujaLj69+6tanlrZmTrqjVRAJsVAUx9OTLy7NP5JVmL++rPG+/VrPGHWE/N+tjnZYj79i39l39WRv7HCW2iK/Cnzr1sbbLAx1j8+lsa3YUMdeW8fcZtBa5JS19VxP/sxmZ92ehV+NzXxEF8UHUwTXC2FyjTpeIOBExUtIVNjn6ln1FrYOOdTRrextLGbrtvh6fy7XzPXemaXMX2+nPFsoyuWiVc28Ey1z3hZGlX501kvU+rjX+R74M1D4n6VX8Y32PK4jlS+6Vp0/emNNJk2/p3aymbw+zxvWIzDUyFmrGnHs1Eft6yzwqP2NR7h2/cv5M/T170d2j07RZyT7fc+7abWeaNYgqalvUjrH1jr/vM3ONb1cQjz45Zpl1UMxa397jRsaXYrXsu7F9pZmsyz5Xe48WuTJp5mp7Zv9zZ9jTO+/169fDWojhfxqo1lCMFylydWxUayGoFbd96d5IXPl6fSPvCpbNOpKvZmUiFsSr/YW6+7rHOs46EC3jelbSEl9ijWVtjxrP3k/J388nVyZFHAevzKPyM7ptJZ4+Ov4i0tuvXdtqaPP2jFL6uITmcd0163Lfa3mmH+ct194aI0L0eQQf7TkTSSyIv9GMhY60cVpW5NemvmK29bS1btNyrJ779inRjvYR46PnSeOM3F8fve4Qb5lHtm2y7fRnna1VsbUujHsNvf1kP3taU0hJeSiXwUgatcTbr5fX7mtuS4zaPuizf7CKRxbEefVTqu1EiDxdI7XN6iMmSl93yFFj9XmMOtItd7zkNZMi2Mlj+sRnejViDC/vunr7yWpvQ640bWrG7pv6rRfLtuP3nh/223t4WeY1i2cFdVqP0Fijs3lsQTx6oTFXr8uHR+Sxd44VGTultnj+NZd7tuSlkYt/fU7Oc6SVX8ijxl9vjrGjaqNp22lp3mBGj7mXi91zvBruEK9l5JrfqiCedYK0ic76HU86SKTtkVm9Mo+i+D9teBQTpcY/gr/nVcQeKOWz3xf7NuXHkTMrax2ltf9I3hdry31MuUUnp4Gtx/K2+xo1CUsOmraaNnn5nvLnh1+F51tyObPcr9S3/FF/hfFErKnFix7La9S19WluVRCjB/2JVS6UbM/PUL6Q1S9xMy6ALevW0vdD8wJqXZeIvHqpv8haZ/rm6yXrFTelHi+yPxH1kS2l+9Fr93VV0pyk7auwFI1r7xGbu+yfNuvNclRGjy6I+y9y26Wgf35zrDqvtr2ltersbVpm0dL341qc+/deLp/cc5YRbHPMR7aM90zHVT7cIT6xFHC5FnIbHU+cV+HPGLpobet3pGnf+oa0Re3cHZ8NRnp0QfxjzcP8mlWvPG0v36uJWpWRq2AZ69zW0jfSrHFzbLnEHCG2MS3ykXMFnjUHTXtNm2FMyej3ay2sZkhNmw99VmeWUY5l+vUN4rlFqY3u8Z5/fm1GjTtqnLXpj8VR66XPyO82BXGvRe+3yO0Z98sNb8d95N1jtn6v3dcVzD3KIkaPiBErZu/mjhRrZE17TZsZ5LzG7Xk5lx/WrHIFbNteH8mSaX7rarNrffM0SvxHnNbXe8a3KYhxFXtwxEarib4Ajss8Qu1uYLTYqLH7zRPN0+e+cneIa6yrs53+rNO10pPjyS0EzQF8vPshxxrLpj16e4SavtFLaqOOyGjSYYtEQYzFjbgAregpF8X5+1fOYNa+sGamz/PdUo7fU8TolruTPYwbMX/nuLfraNbxz+01/V+7r8fnMJZ8RZmxX+Ss/CiIu+hxmPSIGafnQboSzV7QtLk73RzlVhHHjTxKD3NGrembUd/ostyR4n1DcCf5dR/5+eHynrccE6V5AHa9zvVbFMScNKP4D7OR+8ifZTvN2Jo2ZyPXbxzPSthFjpKLZdk39Vwskez6loe6eLaPYWQ0LJG362v3VaJr9aZt+xn/dfhe39+nPfo5QntEWD3xc8Q93aIgxve7y8W0V54jLmu9ci+zjThiDTxjePpEiBg3Isabbl/2K+bkiLW51nrHrVEf/da0L0++ljcnd6Q91rTt+itnMnsv9VgjCuJ0h3dZIw+9lrVo6TvDOvmO3MPRVso9do+Om1lupHGjx2m+Q5z8fbPrtR3+yLKssyU3zZiWsT96f1xi/4wnvytLLF0rjVqkuN8sjZks56MGBfHionf4SHMuOfkV86yjN39vvz1dDM+sctritPXO6xHT7p2Fbl+8eV9oc/Ntec7Cl3EHikRa55pTj3lMSpFiOheAmj75NpqeOW2rVBr1WEDX10WTuaYNMNLyBfHTT5r3/NsucHYt47X0xSiR51VkrJzII0rKNfcybxl/lZ82fbIoz3fLPPKLiPEm7aEybw6eET19NCxFdJnUW9peZ+t9fHNQo2mDq/7XnGv8lfZV5OyXL4hXErnwdnNHrxl9csSOV17XdVd8Jsv9tBiRMaV9mtseNX6vF65cfpacLW1L8jFskbfd11Vtpz9jlNepViDvn7M+jnSOqxlH00bDE8f7U5wo2mNH2w5xKIhvZe4pEnEZscSwtO0havyoOHcw9wjtQzMnTZs6fwR/zzjNObwuD+I0J/fDk93P3frXr3/6tfTdqxfN1zyP49qy0LSurYym/5mnT0r+finNL7TRjoK4g153gt62FHqFL2oZo6VvjFEZrH8JHLUSUa4rOnsGtX2sya3WRtNf2+rKcyXS9dDdKbXFqtG08bMXqpbip9TydfpTx55rpPO49e+tBa5tL49eg9HjrcW2b+5q6YL42Qeg5BkHqJft2PGv5bGnLo4tt/4i82mPFVFi+bXn3y43x/K86ysSNx/PyutG17Xqr2WGP3Pwz+YYS19y79vJv4GiJcMjTRxbG03rNvpVtbFEtbTV8rz19eqRf4vIfJYuiEcaeUBpyTu6d86942Md0ftaPnrzvP3WE72iZ73j5/QY0x8z9li5RouN71XLojVDTdGsHUPTrt7meiRoYkYZORZiRO8zCuIbex8M/peTvvR5RR/UI9/eeHIfl92qPKt2NXcV547eg2avaNqYdQl6su3+F8jplFtIW+TYZVJf3d1PTZu81+VrTe9synrEjLJybjLFyXNzFMRfQXml76B0go8+8dtn3x5B67w2kWsVGWt1q85V84ZHbiFrn/8xi4icZjDnrbxctq9v2SvzSOt1+rPWpvY4kiau3ObYQju/EWbk0itui5Vy6pHLL//+9W+lNnCpX3F77ExpTI1rXlvhebuIGCU9Y3/EjREX6az9CLgPaa7S9jb99mEPmmw1bT4sbc+20581tTaa/h/ZInJLKW0vMZB+rtcyVype9bFTqrUufXa4Zt9u3zv/vM25ny6OZY/m1cap3bPW5ddmxBho88v/LhTE29Z+kH4T22rYWseYMWZJfC4zLyrxs8mbOceZY0frOxff0VC7e+yLKNl2X9dw2C99d9LFdR22nz+Ud44ttOG0BbRVjzhSsasds168rmOlXOZaZyV6ZcJHJrrTXhKPpB1e3+4bM6VST3+8e2mfp7Tf3mzjWF5w8tts432L6Fkf1/aVeS7Xro1uDrpWki3zyNpCw943v6Kedb4WnJkoW0ppuz7/2eOWcctHSc01u/o5X52N2E7zeCUr5aVbeWnrlbX9k/Rcm1/+4+vfSW1gdN1h9peAdr7bHfEHmz0HxIjflzazX1xzY7Y8d2S706s7C2qtdBFK5Pno2nxY2npYZtuSS7WvcNfYO+5PkWuPcC6Q6wXw/rF9rKtrjHzU47PW8ysi07OY+ftYR7a2R5xfUkrpP/3yH6R2j6D5yzB+vgLV6+ekihpTH2eNE1qf77eyr4C9R80+WmzkFZSPcmsBMIJl/e25yneU916XB/OJqYiXbzFCUam4tUbUtte2y5H6ts1Bbt2jkO4Rc7SZBf9IvWf5S0op/fvXv021v1zH54gjzVjLGWPqlA7w3gd+2ZZ55JefR+Tsylm2juLv/9p99YtY/37isouL5HEdPS6f9xHwiXf+cw3b7qvCtvvfSHs+fNo5hvjNfiztXybTfKRiL1/8yrP8hgI0JV2umjZ71vYjrZxblN8+Q/yffvkP6f/4hY9PjPASLnV9DryWy2uePs/4sXsYkWX+ReRuWlZKP2N9y15a5hlDswZRbeLZ18/e40fLHF19fy2MX78mnY/hv3f3Ov2Z334tQ4/ta9/1ZR+rz+ui9g3BbCvlsqIR63P4S3X/8fXv0n/65T9U7xY/XdxOcd5maOIb82fO9r53Erdvy873o757RX+MWNt4tazHzCjm+LBFkQqxvag2by/T2CW2GPmCUdd3J3NpzcX4iX8tZOvKa1Mr97RHsKZsP7b38faT9IirXbsSTRvojFrL11b4PMTfb/+QUkrp//rrP/w0fo1K623saG/ShUGTk9Tmuj1/US5p3Z5Sfp6lfqXsdO33z/cZUzuepu95pPL20vf1MaX4mja1MffbPO1qf2Nd0+51+Spv20fS5J9rk8snFzeXaz7e+WtkX3kemm2aeWrWpzxmLl5pXqWxC2v/Ks0ll4uurfS8ZT62Nck/n17vZ3PtbTnqnt8/d/z++vi67bi1ltfx+f33+XGv7Wrb8i1q/aTt57kdt5XZtmmeKbO0PavNL9KocXJGjVwsiAEAgN//SH9J/yP9JaV0fFH/p/SX9E/pL5fCUyqU5UI1X5TmC9j9Y6lfuSDO9cwVMFJR06NwfW+Pj3vdpnmmzNL2bEyhOmaUnJHjUhADADDJP6W/pP/5a9H8p/TPKaVr4SvfyT6WDXIBvH9cLmTP49TaXKOV2tW25Vvp+ua2lbdKhZZtzPr611ja5owpVceMcjZ6TApiAAAW8T/TX9L/TH9N/5T+kv78293lXEF8/hhFviC9FsD77zWFbrld7tlcESMVNrXetsJ0v60+qj+u55k8bbsaaZ4xxoxyNnpMCmIAABb139I/p/+e/vm34uDnz30ZKRe2+ef3X8/bfr6rx/h5VCpgdAVmvpWu7/l5uZTyxM1vO6+WnqVtiWau7caMsjd6vJQoiAEAWN5/T/+c/pz+WrhrLBe218f5UvQaQ9OuXjDpt+mLy/I2uXjzxS1t1+d8ZmmbI880xqhx9saPmNLvpQYAAGCuv01/SCml9Of01/T//Voc70UUw2e6QqjepqX4LGkphlv0jI23mWt8+D3EAABgXX+Tfkn/W/oX6V+nPxSLh3oxrP++tM3Sz8seU1cMa9p49YyN/vjIBAAAN/X/pj+nP6e/ZgvWfBF7vkd8bfv+/vhMuSAuF6JSgVgaQVuYn5+1jRe1XTd2jqfPnu4tQLtx48xFQQwAwI39Of01/df055RSuXB9Xb7m272/LxfDx+/jPzus73N8ViqmpO0pecb+2aKJv2dtnzOmUB01ynwUxAAAfIH/mv6c/vnXzxbnC+NrceMvht/feYrI2gi6PsdnNMWU1Ma/fU5BPKZMTWnUSCPGkPAZYgAAvsD/mv4m/SH9MqgYrhcxusJ2jWJYEl0M42iV9aMgBgDgS3yK4pSOhYZUdNiLYalMlJ5vL4ajxEfEHVEQAwDwRf5t+pv0L3e/VTVXvPYqAnVxdcXwlb2f1EbaLmntv7re8+sd34KCGACAL/Mv0+/Tv0l/oyqGI+8Ol7wyj67fHXnuKO9JbaTtKena4DtQEAMA8IX+kH5J/+bXf9DjQypuW4rh0pZSMVzTuxjWkGJI23vxvCFZ0WqzoCAGAOBL/T79kv1M8fv7ucWw3KfWqo0UVdr+DP1WoV9kPwpiAAC+2N+mP/xWFH+MKIZrLbzFsDyWrs1Mq+f3VBTEAAB8ub9Nf0i/D37Jf6V6cfcqtOhZDGtIcaTt75nJrZC36srFnh0AAGBJ/0v6XUrpeLf3XLLmSljNX8y7bs+36F0MS+2k7XXSW4D+Rhbi40ZaAwUxAAAP8Pv0S/rb9DdSs4MRxfCRrlWO1FPanlKpzfxC+FusvIoUxAAAPMTv0+u3j05c7wSfvx9TDL8yj/LbyzRtJPnZRkT+ERutp/hM4yPGoiAGAOBB/nX6vbkYlkrDV/J9rjaiGNawxZFmi29EQQwAwMP8q93vJ9YUwzVSIVzaKhXDWm29316/fZWjyS16GTdy9EjR8XqgIAYA4GE+H52YWwzXC1Bp7JSi2ugK4bmklUYrCmIAAB7oX6XfH74fXwyXSWOnFNHmXQhr4kTwj+Pv6RM/3iY1WAAFMQAAD/X56ISlGNZ8Xrjf1gh3uCP8oXn7gAgUxAAAPNTv0sv0D3ZoCmGpmK7RFn6adtc2UnarmZPrnFHn058FAADg6/yLX//Bjo/yRx3ailmpv5YmyvV+t6aXLCaKxivz6N5W/9gEBTEAAA/2u/RKv6v8aL79IxK6YlhuYW0TVwi3smVhax1r5thzURADAPBw/+K3kvgoopCNiGGzTiFsd9e874+CGACAh9vfJf6IKGSl7RaaWJqcR9NndG2p7xtj9HgroSAGAADpb3afJZYKS+ke7M92ucSSW2jbaFod2Xv0sk4mPa38OeLjLyEEAACP9LlL/FehnVS6vTKPSuQW344VWAV3iAEAQErpeJc4R3dXWEfbVtPOc3d4BPk+u3drD+NHXAkFMQAASCmlwl+tk4vdXp9+1UTxFsPWXtb2dbHR7mTVj01QEAMAgN/8zak0kEo3aXuOpo+ujabVla9XFHl0uUW8GWOuhIIYAAD85g+70kC6K1y+n1ymKbw0bbx6xpbNHR1lFMQAAODgd8K91/K2+kcuIstB793hUXp9jKSPsbmt+LEJCmIAAHBw/tjEh6Wo9RbBmvbeYtjXy9/vR3sE9MWvXQMAAAe/uO5vesvUH5r+3lF8vfz9ftgi2FrHmDHmarhDDAAALrSfJf7QtKnR9L9LMfzKPMLRah+boCAGAAAXf/j1PrFU0r3bSK3mmZfZvJFt7pJnXxTEAAAgK/fRib3X7msLTQRP0W3v8aOlr7e3rxciUBADAIAs7z/UYaGJc6diuKXvePfKticKYgAAkPX7TJlwLKF8BdVr97/kfsWwL4KvV4ufEWd9nnfWuDkUxAAAoGj/sYnWok1bBM/SkltL3/Hule0I/No1AABQ9Lv0Slv2Xp6uqNK1yht5d9jb736eM1MLCmIAAFCU/4t19aIqouS6UzE8u7/euJHuhoIYAAAUSb9p4kPXSmdkMdxq1rg298hyJj5DDAAAqo5/ue74meLozwV7iuEWLaO19B1Hl+Wsv+A2a9wz7hADAICqn7vEo8tVHW9O3n4plfraI9p7WPSN/k0oiAEAQNWnIO5ZXnlLbV8vf79IfXPoG/3b8JEJAAAg+kP6ndTE7P1xi9ftiuHW/v2tn+FquEMMAACGuJZp/sLN29Pb76O1/0dUnKM+UZ+AO8QAAEBU+meca16n/69b7Lw9vf32Wvt/RMU5ao866y+4zRp3jzvEAAAghFySyS1qvL29/Xrok0ufqE/CHWIAAKDy+1PZUL4DfCa3kHh7e/udyXEiWnj0ifo03CEGAABqtvLL1jrHG8HbLyciVkSMqz5Rn4g7xAAAQEX/OeL2O8Ip+SN4++VExIqIcdUn6gqf552BO8QAACBIXJHmjeTtlxMRKyLGUXzEFWxp7sy4QwwAANR+ly0dYu4Ip+SP5O0HpMQdYgAA4BZbgnqjefuV2ONde9hjYCYKYgAAoPa79Ep/SSl5/3W5aJFZRMbCvVAQAwAAkxWK4cgMImOlFB9vtNmf552BzxADAACT2QVx1Og9PnccHe9JZv6GCwpiAABgMrN4iCo4o+Ls9YiJMfjIBAAAWF5UsRkV56xXXIwx800eAAC4odEfmYgYrcfHI95Gr8bMDxZ8LwpiAABgMrIAbB2rXyH81jP2TLPK7lnj8pEJAACwnDsUmqPvDY/0vTPLoyAGAABmr/RKW6f7eRHFWESMkm8uhFPqu3ar4iMTAADArFcBEVGMRcTIef363zf77tmVcYcYAABMF1WIRcXZ+/Yi+OMZs8yjIAYAAGa/pFf6a6ePTHj1KOgohsealQcFMQAAuLUeRdRTCuGU+qzf3VAQAwCA24ou5p5UCK9m5sr3+kw8AAD4cr9MLGGif7/wvf7CXNxHVVaZ8ew8KIgBAMCtRBdP9ymEY60y6xXy4CMTAADgFqILp6cWwinFr6XXKnlwhxgAALiM/MhE5Ej3+nhEvFVmvkoeKXGHGAAAPMSTi+CPVVZglTw+uEMMAADcRhSZESOMyHN1q6zAKnnscYcYAAC4vVLk7zyIRyH8tsoqrJLHGQUxAABYlreAohD+scpKrJJHDgUxAABwe6V8oTPrrvFzCuEtaUpMucUYq+RRQkEMAADcXoUPTUQUyasXUatbZf1WyaOGghgAAAwRUSTXPOfusIyVsKEgBgAA05SKZGtBRzH8Y6WVWCmXGn7tGgAAWMpdiqgVrbR2K+UioSAGAABNZt+dnT3+KlZahZVy0aAgBgAATWYWPxTDbyutwkq5aFEQAwAA3NhKBehKuVhQEAMAgFvi7vB9C9DV8FsmAAAAboA3AP1QEAMAgCalf5yjp+8uDu85uzvm/EFBDAAAbuWe5WLJd83mriiIAQAABvjm0vfuM6MgBgAAt3GXovIueeKNghgAADR7pVfaBn+OeA2Uvt8wfwpiAADQbMRfq1ur9FwrG7ShIAYAAMtbp/xcJY81fMtq8A9zAAAAqHxL+YczCmIAALC0Ne4Or5DDWr5pRSiIAQBAs15Fa6+4NivkgJ74DDEAAFjKGkXwRzmXrbr1u33bvCmIAQDAdGsVwSl9X8mHGgpiAAAw3HoF8N7Kuc33jatDQQwAAEL8kl7pr5XfRrx2EfxxhxwRjYIYAAB0cY8CeM+e79M+R/ytc6UgBgAAYe5XBH/cNW9E4NeuAQCAIHcsKl/pnnkjEgUxAAB4KAphi29eLQpiAAAQ4l4F072yRV8UxAAA4GFii+Hy79X4HrErth7+Uh0AAHiIby/r4MUdYgAA8AAUw15PWDnuEAMAgC/3hJKuzdNXiIIYAAB8saeXem+sQh0FMQAA+EJjS8DZ/2LdzLG/AQUxAAAI80pr/NaFfYG4Qj49UATHoSAGAACBZpbE+RLx8+ysrLA+CmIAAHBzx0K4dOf0CXeN4cOvXQMAADf1St4PDvh7llFk3xd3iAEAwI3Uy1hrkXvnj1PM/ot834SCGAAA3EDf0o+PUzwbBTEAAFiYvhDWt6y7811j+PAZYgAAECaqKO3zKV+b+RlgFO4QAwCARfjLT39PmeXjFKM/1zt6vG9FQQwAACa7T0nHxym+EwUxAACYJKYQjoliQ2H8XSiIAQDAQDPK134xwUlxAAAFoklEQVQojL8DBTEAABigTyHcJ6rdKnnAh98yAQAAOuJ3NfTG3el23CEGAAChXrsCuGexRpmNKNwhBgAAofaF6itxjxjr4w4xAAAY4lwUt9w9psBGJO4QAwCAKbh7HKflzQW4QwwAABZguXtMAY1oFMQAAGA5ln8uGWhFQQwAAJbGHWH0xmeIAQAAvgB30v0oiAEAAPBoFMQAAAB4NApiAAAAPBoFMQAAwJfgc8Q+/JYJAACAm+I3cMSgIAYAAFgchW9fFMQAAAALofgdj4IYAABgEorfNVAQAwAADEDxuy4KYgAAgGAUv/dCQQwAAMK90nN+BRjF7/1REAMAAChR/H4nCmIAAAABhfB3oyAGAAAooBB+BgpiAACAHYrg56EgBgAASBTCT0ZBDAAAHosiGClREAMAgIehCMYZBTEAAPh6FMGooSAGAABfi0IYGhTEAABgSRSzGIWCGAAAdEFBi7v4RWoAAAAAfDMKYgAAADwaBTEAAAAejYIYAAAAj0ZBDAAAgEejIAYAAMCjURADAADg0SiIAQAA8GgUxAAAAHg0CmIAAAA8GgUxAAAAHo2CGAAAAI9GQQwAAIBHoyAGAADAo1EQAwAA4NEoiAEAAPBoFMQAAAB4NApiAAAAPBoFMQAAAB6NghgAAACPRkEMAACAR6MgBgAAwKNREAMAAODRKIgBAADwaBTEAAAAeDQKYgAAADwaBTEAAAAejYIYAAAAj0ZBDAAAgEejIAYAAMCjURADAADg0SiIAQAA8GgUxAAAAHg0CmIAAAA8GgUxAAAAHo2CGAAAAI9GQQwAAIBHoyAGAADAo1EQAwAA4NEoiAEAAPBoFMQAAAB4NApiAAAAPBoFMQAAAB6NghgAAACPRkEMAACAR6MgBgAAwKNREAMAAODRKIgBAADwaBTEAAAAeDQKYgAAADwaBTEAAAAejYIYAAAAj0ZBDAAAgEejIAYAAMCjURADAADg0SiIAQAA8GgUxAAAAHg0CmIAAAA8GgUxAAAAHo2CGAAAAI9GQQwAAIBHoyAGAADAo1EQAwAA4NEoiAEAAPBoFMQAAAB4NApiAAAAPBoFMQAAAB6NghgAAACPRkEMAACAR6MgBgAAwKNREAMAAODRKIgBAADwaBTEAAAAeDQKYgAAADwaBTEAAAAejYIYAAAAj0ZBDAAAgEejIAYAAMCjURADAADg0SiIAQAA8GgUxAAAAHg0CmIAAAA8GgUxAAAAHo2CGAAAAI9GQQwAAIBHoyAGAADAo1EQAwAA4NEoiAEAAPBoFMQAAAB4NApiAAAAPBoFMQAAAB6NghgAAACPRkEMAACAR6MgBgAAwKNREAMAAODRKIgBAADwaBTEAAAAeDQKYgAAADwaBTEAAAAejYIYAAAAj0ZBDAAAgEejIAYAAMCjURADAADg0SiIAQAA8GgUxAAAAHg0CmIAAAA8GgUxAAAAHo2CGAAAAI9GQQwAAIBHoyAGAADAo1EQAwAA4NEoiAEAAPBoFMQAAAB4NApiAAAAPBoFMQAAAB6NghgAAACPRkEMAACAR6MgBgAAwKNREAMAAODRKIgBAADwaBTEAAAAeDQKYgAAADwaBTEAAAAejYIYAAAAj0ZBDAAAgEejIAYAAMCjURADAADg0SiIAQAA8GgUxAAAAHg0CmIAAAA8GgUxAAAAHo2CGAAAAI9GQQwAAIBHoyAGAADAo1EQAwAA4NEoiAEAAPBoFMQAAAB4NApiAAAAPBoFMQAAAB6NghgAAACPRkEMAACAR6MgBgAAwKNREAMAAODRKIgBAADwaBTEAAAAeDQKYgAAADwaBTEAAAAejYIYAAAAj0ZBDAAAgEejIAYAAMCjURADAADg0SiIAQAA8GgUxAAAAHg0CmIAAAA8GgUxAAAAHo2CGAAAAI9GQQwAAIBHoyAGAADAo/3/AO8gByk2BEwAAAAASUVORK5CYII="
        ></image>
      </defs>
    </svg>
  );
};
export const PaperDisplay = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="329.56 10.5 592.94 1017.94">
      <g filter="url(#filter0_f_711_12236)" opacity="0.2">
        <ellipse cx="618.5" cy="657.5" fill="#29AC00" rx="229.5" ry="88.5"></ellipse>
      </g>
      <g filter="url(#filter1_f_711_12236)" opacity="0.12">
        <ellipse cx="642.5" cy="457" fill="#29AC00" rx="228.5" ry="97"></ellipse>
      </g>
      <g filter="url(#filter2_f_711_12236)" opacity="0.04">
        <ellipse cx="628" cy="647" fill="#29AC00" rx="294" ry="313"></ellipse>
      </g>
      <path stroke="#fff" strokeOpacity="0.1" d="M330.5 616L330.5 11"></path>
      <path stroke="#fff" strokeOpacity="0.1" d="M721.5 562L721.5 11"></path>
      <g filter="url(#filter3_b_711_12236)">
        <path fill="#fff" fillOpacity="0.06" d="M921.922 671.089v279.927L532.845 1028V725.77l389.077-54.681z"></path>
        <path
          stroke="#fff"
          strokeLinejoin="round"
          strokeOpacity="0.1"
          strokeWidth="0.889"
          d="M921.922 671.089v279.927L532.845 1028V725.77l389.077-54.681z"
        ></path>
      </g>
      <g filter="url(#filter4_b_711_12236)">
        <path fill="#fff" fillOpacity="0.02" d="M532.845 1028L330 917.699l.158-302.23 202.687 110.3V1028z"></path>
        <path
          stroke="#fff"
          strokeLinejoin="round"
          strokeOpacity="0.1"
          strokeWidth="0.889"
          d="M532.845 1028L330 917.699l.158-302.23 202.687 110.3V1028z"
        ></path>
      </g>
      <g filter="url(#filter5_b_711_12236)">
        <path
          fill="#fff"
          fillOpacity="0.08"
          d="M534.97 725.981L330.157 615.47 721.271 561 922 671.09l-387.03 54.891z"
        ></path>
        <path
          stroke="#fff"
          strokeLinejoin="round"
          strokeOpacity="0.04"
          d="M534.97 725.981L330.157 615.47 721.271 561 922 671.09l-387.03 54.891z"
        ></path>
      </g>
      <path
        fill="#fff"
        fillOpacity="0.2"
        d="M530.73 473.519L330.886 356.58v-74.014L530.73 399.504v74.015zM530.73 558.11L330.886 441.171v-24.153L530.73 533.956v24.154z"
        opacity="0.14"
      ></path>
      <path
        fill="#fff"
        d="M734.392 597.27l-3.56.521c-.764.156-1.363.877-1.363 1.641v10.54c0 .798.642 1.345 1.441 1.232l3.794-.555c1.702-.261 3.377-.044 4.836.634 2.813 1.259 4.541 4.037 4.549 7.31v19.838c0 .304.235.521.539.487a.598.598 0 00.277-.113c7.788-5.027 12.685-13.727 12.598-22.417-.252-12.52-10.54-21.037-23.103-19.118h-.008z"
      ></path>
      <path
        fill="#fff"
        d="M738.541 628.726l-3.794.556c-5.148.747-9.316-2.813-9.325-7.953v-21.358c-.026-.772-.668-1.285-1.441-1.172l-10.54 1.546c-.798.112-1.441.859-1.441 1.649v21.297c0 12.563 10.184 21.245 22.738 19.396l3.925-.573c.772-.148 1.38-.868 1.38-1.641v-10.531c0-.799-.642-1.346-1.441-1.233l-.078.017h.017z"
      ></path>
      <g filter="url(#filter6_b_711_12236)">
        <path fill="#fff" fillOpacity="0.1" d="M530.73 265.975L330.886 149.036v-24.153L530.73 241.821v24.154z"></path>
      </g>
      <path stroke="#fff" strokeOpacity="0.1" d="M921.5 671L921.5 11"></path>
      <path stroke="#fff" strokeOpacity="0.1" d="M532.5 726L532.5 11"></path>
      <defs>
        <filter
          id="filter0_f_711_12236"
          width="587"
          height="305"
          x="325"
          y="505"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"></feBlend>
          <feGaussianBlur result="effect1_foregroundBlur_711_12236" stdDeviation="32"></feGaussianBlur>
        </filter>
        <filter
          id="filter1_f_711_12236"
          width="585"
          height="322"
          x="350"
          y="296"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"></feBlend>
          <feGaussianBlur result="effect1_foregroundBlur_711_12236" stdDeviation="32"></feGaussianBlur>
        </filter>
        <filter
          id="filter2_f_711_12236"
          width="1256"
          height="1294"
          x="0"
          y="0"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"></feBlend>
          <feGaussianBlur result="effect1_foregroundBlur_711_12236" stdDeviation="167"></feGaussianBlur>
        </filter>
        <filter
          id="filter3_b_711_12236"
          width="437.965"
          height="405.8"
          x="508.401"
          y="646.645"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="12"></feGaussianBlur>
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_711_12236"></feComposite>
          <feBlend in="SourceGraphic" in2="effect1_backgroundBlur_711_12236" result="shape"></feBlend>
        </filter>
        <filter
          id="filter4_b_711_12236"
          width="251.734"
          height="461.42"
          x="305.556"
          y="591.024"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="12"></feGaussianBlur>
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_711_12236"></feComposite>
          <feBlend in="SourceGraphic" in2="effect1_backgroundBlur_711_12236" result="shape"></feBlend>
        </filter>
        <filter
          id="filter5_b_711_12236"
          width="660.843"
          height="233.981"
          x="295.657"
          y="526.5"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="17"></feGaussianBlur>
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_711_12236"></feComposite>
          <feBlend in="SourceGraphic" in2="effect1_backgroundBlur_711_12236" result="shape"></feBlend>
        </filter>
        <filter
          id="filter6_b_711_12236"
          width="267.844"
          height="209.092"
          x="296.886"
          y="90.883"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="17"></feGaussianBlur>
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_711_12236"></feComposite>
          <feBlend in="SourceGraphic" in2="effect1_backgroundBlur_711_12236" result="shape"></feBlend>
        </filter>
      </defs>
    </svg>
  );
};
export const Discovery = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="125.61 151.55 901.18 1510.42">
      <path
        fill="#000"
        stroke="#fff"
        strokeMiterlimit="10"
        strokeOpacity="0.1"
        strokeWidth="1.226"
        d="M319.152 570.685c25.428 0 46.042-20.614 46.042-46.041 0-25.428-20.614-46.041-46.042-46.041-25.429 0-46.043 20.613-46.043 46.041 0 25.427 20.614 46.041 46.043 46.041z"
      ></path>
      <path
        fill="#fff"
        fillOpacity="0.08"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.613"
        d="M319.602 558.557c18.73 0 33.914-15.184 33.914-33.913 0-18.73-15.184-33.914-33.914-33.914-18.731 0-33.914 15.184-33.914 33.914 0 18.729 15.183 33.913 33.914 33.913z"
      ></path>
      <path
        fill="#fff"
        fillOpacity="0.08"
        stroke="#fff"
        strokeMiterlimit="10"
        strokeOpacity="0.1"
        strokeWidth="0.613"
        d="M319.602 549.35c13.644 0 24.705-11.061 24.705-24.705 0-13.644-11.061-24.705-24.705-24.705-13.645 0-24.706 11.061-24.706 24.705 0 13.644 11.061 24.705 24.706 24.705z"
      ></path>
      <g filter="url(#filter0_d_718_10273)">
        <path
          fill="#1854DF"
          stroke="#000"
          strokeMiterlimit="10"
          strokeWidth="1.226"
          d="M741.393 1414.02l-169.346 76.59-174.062-68.95 174.062-72.54 169.346 64.9z"
        ></path>
        <path fill="#1854DF" d="M741.394 1414.02v171.37l-169.346 76.58v-171.36l169.346-76.59z"></path>
        <path fill="#06246C" d="M572.047 1490.61v171.36l-174.062-68.95v-171.36l174.062 68.95z"></path>
      </g>
      <path
        stroke="#92FED8"
        strokeMiterlimit="10"
        strokeOpacity="0.1"
        strokeWidth="1.226"
        d="M427.407 927.558V736.207c0-35.935-29.197-65.132-65.133-65.132-22.01 0-39.978-17.967-39.978-39.977v-60.639M922.867 706.787H792.825c-30.994 0-56.149 25.154-56.149 56.147v135.653c0 9.882-8.085 17.742-17.743 17.742h-67.828c-30.995 0-56.149 25.155-56.149 56.148v449.183l69.4 27.17v41.78"
      ></path>
      <path
        stroke="#92FED8"
        strokeMiterlimit="10"
        strokeOpacity="0.1"
        strokeWidth="1.226"
        d="M868.74 835.926v112.519c0 30.994-25.155 56.145-56.149 56.145H651.33c-30.994 0-56.149 25.16-56.149 56.15v38.41M820.227 608.19H680.528c-30.995 0-56.15 25.154-56.15 56.148v96.349c0 30.993 25.155 56.147 56.15 56.147h34.363c12.128 0 21.786 9.658 21.786 21.786v46.49M988.225 501.509h-63.561c-30.995 0-56.149 25.154-56.149 56.148v92.98c0 30.994-25.155 56.148-56.15 56.148h-14.598M514.775 408.306v237.841c0 29.197 23.808 53.003 53.005 53.003h3.369c29.198 0 53.005 23.807 53.005 53.003v13.7"
      ></path>
      <path
        stroke="#92FED8"
        strokeMiterlimit="10"
        strokeOpacity="0.1"
        strokeWidth="1.226"
        d="M680.528 608.191h28.748c30.995 0 56.149-25.154 56.149-56.147v-247.05"
      ></path>
      <path
        stroke="#92FED8"
        strokeMiterlimit="10"
        strokeOpacity="0.1"
        strokeWidth="1.226"
        d="M765.425 539.467v-19.539c0-30.994-25.155-56.148-56.15-56.148H676.26M594.956 1147.21v-20.22c0-25.82-20.887-46.71-46.716-46.71s-46.716-20.89-46.716-46.72V914.756c0-28.073 22.684-50.757 50.759-50.757h92.309M162.159 954.285h170.918c52.106 0 94.106 42.223 94.106 94.105v48.51c0 19.76 15.946 35.71 35.711 35.71 45.593 0 82.651 37.06 82.651 82.65v183.94l-98.148 42v22.9"
      ></path>
      <path
        stroke="#92FED8"
        strokeMiterlimit="10"
        strokeOpacity="0.1"
        strokeWidth="1.226"
        d="M427.407 1063.44V906.671c0-49.634-40.203-89.836-89.839-89.836h-42.224c-35.935 0-65.133-29.197-65.133-65.131V676.69"
      ></path>
      <path
        fill="#000"
        stroke="#fff"
        strokeMiterlimit="10"
        strokeOpacity="0.1"
        strokeWidth="1.226"
        d="M868.74 863.999c21.708 0 39.305-17.596 39.305-39.303 0-21.707-17.597-39.303-39.305-39.303-21.707 0-39.304 17.596-39.304 39.303 0 21.707 17.597 39.303 39.304 39.303zM961.722 765.852c32.623 0 59.068-26.445 59.068-59.067s-26.445-59.067-59.068-59.067-59.069 26.445-59.069 59.067 26.446 59.067 59.069 59.067zM967.114 563.721c32.623 0 59.066-26.445 59.066-59.067s-26.443-59.068-59.066-59.068c-32.623 0-59.069 26.446-59.069 59.068s26.446 59.067 59.069 59.067zM662.111 884.662c11.288 0 20.438-9.151 20.438-20.438 0-11.288-9.15-20.438-20.438-20.438-11.288 0-20.438 9.15-20.438 20.438 0 11.287 9.15 20.438 20.438 20.438z"
      ></path>
      <path
        stroke="#fff"
        strokeMiterlimit="10"
        strokeOpacity="0.1"
        strokeWidth="1.226"
        d="M501.524 967.535V791.681"
      ></path>
      <path
        fill="#000"
        stroke="#fff"
        strokeMiterlimit="10"
        strokeOpacity="0.1"
        strokeWidth="1.226"
        d="M501.524 812.12c11.288 0 20.439-9.15 20.439-20.438 0-11.287-9.151-20.437-20.439-20.437s-20.438 9.15-20.438 20.437c0 11.288 9.15 20.438 20.438 20.438zM192.704 1020.76c36.717 0 66.481-29.761 66.481-66.477 0-36.715-29.764-66.478-66.481-66.478-36.716 0-66.48 29.763-66.48 66.478 0 36.716 29.764 66.477 66.48 66.477zM311.066 909.815c11.288 0 20.438-9.15 20.438-20.438 0-11.287-9.15-20.438-20.438-20.438-11.288 0-20.439 9.151-20.439 20.438 0 11.288 9.151 20.438 20.439 20.438z"
      ></path>
      <path
        fill="#fff"
        fillOpacity="0.08"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.613"
        d="M192.703 1004.14c27.413 0 49.636-22.219 49.636-49.631s-22.223-49.634-49.636-49.634c-27.413 0-49.636 22.222-49.636 49.634s22.223 49.631 49.636 49.631z"
      ></path>
      <path
        fill="#fff"
        fillOpacity="0.08"
        stroke="#fff"
        strokeMiterlimit="10"
        strokeOpacity="0.1"
        strokeWidth="0.613"
        d="M192.704 990.667c19.971 0 36.16-16.189 36.16-36.159s-16.189-36.159-36.16-36.159c-19.971 0-36.16 16.189-36.16 36.159s16.189 36.159 36.16 36.159z"
      ></path>
      <path
        fill="#fff"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.613"
        d="M207.751 934.296h6.289l-13.027 14.598c-4.716 5.39-12.352 5.39-17.069 0l-13.027-14.598h6.514l9.882 11.229c2.92 3.369 7.861 3.369 10.781 0l9.657-11.229zM177.206 974.947h-6.289l13.027-14.823c4.717-5.39 12.353-5.39 17.069 0l13.027 14.823h-6.289l-9.882-11.229c-2.92-3.369-7.861-3.369-10.781 0l-9.882 11.229z"
      ></path>
      <path
        fill="#000"
        stroke="#fff"
        strokeMiterlimit="10"
        strokeOpacity="0.1"
        strokeWidth="1.226"
        d="M427.408 781.575c32.499 0 58.844-26.345 58.844-58.843 0-32.498-26.345-58.843-58.844-58.843s-58.845 26.345-58.845 58.843c0 32.498 26.346 58.843 58.845 58.843zM578.561 627.73c25.428 0 46.042-20.613 46.042-46.041 0-25.428-20.614-46.041-46.042-46.041-25.429 0-46.042 20.613-46.042 46.041 0 25.428 20.613 46.041 46.042 46.041zM812.142 652.885c25.429 0 46.043-20.613 46.043-46.041 0-25.428-20.614-46.041-46.043-46.041-25.428 0-46.042 20.613-46.042 46.041 0 25.428 20.614 46.041 46.042 46.041zM695.127 722.732c25.428 0 46.042-20.613 46.042-46.041 0-25.428-20.614-46.041-46.042-46.041-25.429 0-46.043 20.613-46.043 46.041 0 25.428 20.614 46.041 46.043 46.041z"
      ></path>
      <path
        fill="#fff"
        fillOpacity="0.08"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.613"
        d="M427.408 767.2c24.312 0 44.021-19.708 44.021-44.02 0-24.311-19.709-44.019-44.021-44.019s-44.021 19.708-44.021 44.019c0 24.312 19.709 44.02 44.021 44.02z"
      ></path>
      <path
        fill="#fff"
        fillOpacity="0.08"
        stroke="#fff"
        strokeMiterlimit="10"
        strokeOpacity="0.1"
        strokeWidth="0.613"
        d="M427.407 755.296c17.738 0 32.118-14.379 32.118-32.116 0-17.738-14.38-32.117-32.118-32.117s-32.117 14.379-32.117 32.117c0 17.737 14.379 32.116 32.117 32.116z"
      ></path>
      <path
        fill="#000"
        stroke="#fff"
        strokeMiterlimit="10"
        strokeOpacity="0.1"
        strokeWidth="1.226"
        d="M514.776 496.344c58.671 0 106.234-47.561 106.234-106.231 0-58.67-47.563-106.231-106.234-106.231-58.672 0-106.234 47.561-106.234 106.231 0 58.67 47.562 106.231 106.234 106.231z"
      ></path>
      <path
        fill="#fff"
        fillOpacity="0.08"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.613"
        d="M514.775 470.292c44.283 0 80.181-35.897 80.181-80.179 0-44.281-35.898-80.178-80.181-80.178-44.282 0-80.181 35.897-80.181 80.178 0 44.282 35.899 80.179 80.181 80.179z"
      ></path>
      <path
        fill="#fff"
        fillOpacity="0.08"
        stroke="#fff"
        strokeMiterlimit="10"
        strokeOpacity="0.1"
        strokeWidth="0.613"
        d="M514.775 448.507c32.251 0 58.395-26.144 58.395-58.394s-26.144-58.393-58.395-58.393c-32.251 0-58.395 26.143-58.395 58.393s26.144 58.394 58.395 58.394z"
      ></path>
      <path
        fill="#fff"
        stroke="#1D1D1B"
        strokeMiterlimit="10"
        strokeWidth="0.613"
        d="M527.353 412.573v11.679h-10.107v-10.107h-6.288v10.107h-10.332v-10.107h-5.839v-48.062h5.839v-10.106h10.332v10.106h6.064v-10.106h10.107v12.127c4.267 2.246 6.513 5.84 6.513 11.23 0 5.166-1.797 8.759-5.166 10.78 4.043 1.797 6.289 4.941 6.289 9.882 0 6.289-2.471 10.556-7.412 12.577zm-14.149-35.71c-1.797 0-3.369 0-4.268.225v9.433h4.268c1.572 0 2.919-.225 4.267-.674.674-1.123 1.123-2.47 1.123-4.267 0-3.144-1.572-4.717-5.39-4.717zm-4.268 27.4c1.348 0 3.145.225 5.166.225 1.572 0 3.369-.225 4.492-.674.674-.898.898-2.246.898-3.593 0-2.92-1.572-4.267-4.941-4.267h-5.615v8.309z"
      ></path>
      <path
        fill="#fff"
        fillOpacity="0.08"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.613"
        d="M868.74 858.609c18.73 0 33.914-15.183 33.914-33.913 0-18.729-15.184-33.913-33.914-33.913-18.731 0-33.914 15.184-33.914 33.913 0 18.73 15.183 33.913 33.914 33.913z"
      ></path>
      <path
        fill="#fff"
        fillOpacity="0.08"
        stroke="#fff"
        strokeMiterlimit="10"
        strokeOpacity="0.1"
        strokeWidth="0.613"
        d="M868.74 849.401c13.644 0 24.705-11.061 24.705-24.705 0-13.644-11.061-24.705-24.705-24.705-13.645 0-24.706 11.061-24.706 24.705 0 13.644 11.061 24.705 24.706 24.705z"
      ></path>
      <path
        fill="#000"
        stroke="#fff"
        strokeMiterlimit="10"
        strokeOpacity="0.1"
        strokeWidth="1.226"
        d="M737.575 1046.37c21.707 0 39.304-17.6 39.304-39.31 0-21.704-17.597-39.3-39.304-39.3s-39.304 17.596-39.304 39.3c0 21.71 17.597 39.31 39.304 39.31z"
      ></path>
      <path
        fill="#fff"
        fillOpacity="0.08"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.613"
        d="M737.576 1040.98c18.73 0 33.914-15.19 33.914-33.92 0-18.727-15.184-33.91-33.914-33.91-18.73 0-33.914 15.183-33.914 33.91 0 18.73 15.184 33.92 33.914 33.92z"
      ></path>
      <path
        fill="#2AAC02"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.613"
        d="M737.577 1031.77c13.644 0 24.705-11.06 24.705-24.71 0-13.642-11.061-24.703-24.705-24.703-13.645 0-24.706 11.061-24.706 24.703 0 13.65 11.061 24.71 24.706 24.71z"
      ></path>
      <path
        fill="#fff"
        d="M746.784 1019.19c-.898-3.37-1.796-6.74-2.695-10.33 0 .22-.224.22-.224.22-1.797 3.15-3.818 6.52-5.615 9.66v.23c0 .22-.225.22-.225.22h-4.492c0-.22 0-.22.225-.22 2.92-5.17 5.839-10.11 8.759-15.28.225-.22.225-.45 0-.67-.449-1.57-.898-3.369-1.348-4.941v-.224c0 .224-.224.224-.224.224-2.92 4.941-5.84 10.111-8.759 15.051-1.123 2.02-2.246 3.81-3.369 5.84 0 .22-.225.22-.45.22H724.1c5.166-8.98 10.332-17.97 15.497-26.95h4.268c.673 2.246 1.123 4.492 1.796 6.737h4.268c0 .225-.225.225-.225.225-.898 1.568-1.797 3.148-2.695 4.488 0 .23-.225.23 0 .45 1.348 4.94 2.695 9.89 4.043 14.83v.22h-4.268z"
      ></path>
      <path
        fill="#fff"
        fillOpacity="0.08"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.613"
        d="M812.142 640.757c18.73 0 33.914-15.183 33.914-33.913 0-18.729-15.184-33.913-33.914-33.913-18.731 0-33.914 15.184-33.914 33.913 0 18.73 15.183 33.913 33.914 33.913z"
      ></path>
      <path
        fill="#fff"
        fillOpacity="0.08"
        stroke="#fff"
        strokeMiterlimit="10"
        strokeOpacity="0.1"
        strokeWidth="0.613"
        d="M812.142 631.549c13.644 0 24.705-11.061 24.705-24.705 0-13.645-11.061-24.705-24.705-24.705-13.645 0-24.706 11.06-24.706 24.705 0 13.644 11.061 24.705 24.706 24.705z"
      ></path>
      <path
        fill="#fff"
        fillOpacity="0.08"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.613"
        d="M961.723 753.501c25.801 0 46.717-20.915 46.717-46.715 0-25.8-20.916-46.715-46.717-46.715s-46.716 20.915-46.716 46.715c0 25.8 20.915 46.715 46.716 46.715z"
      ></path>
      <path
        fill="#fff"
        fillOpacity="0.08"
        stroke="#fff"
        strokeMiterlimit="10"
        strokeOpacity="0.1"
        strokeWidth="0.613"
        d="M961.723 740.923c18.854 0 34.139-15.284 34.139-34.137 0-18.854-15.285-34.138-34.139-34.138-18.854 0-34.139 15.284-34.139 34.138 0 18.853 15.285 34.137 34.139 34.137z"
      ></path>
      <path
        fill="#fff"
        fillOpacity="0.08"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.613"
        d="M967.114 551.37c25.8 0 46.716-20.915 46.716-46.715 0-25.8-20.916-46.715-46.716-46.715-25.801 0-46.717 20.915-46.717 46.715 0 25.8 20.916 46.715 46.717 46.715z"
      ></path>
      <path
        fill="#fff"
        fillOpacity="0.08"
        stroke="#fff"
        strokeMiterlimit="10"
        strokeOpacity="0.1"
        strokeWidth="0.613"
        d="M967.114 538.792c18.855 0 34.136-15.284 34.136-34.138 0-18.853-15.281-34.137-34.136-34.137-18.854 0-34.138 15.284-34.138 34.137 0 18.854 15.284 34.138 34.138 34.138z"
      ></path>
      <path
        fill="#000"
        stroke="#fff"
        strokeMiterlimit="10"
        strokeOpacity="0.2"
        strokeWidth="1.226"
        d="M765.425 370.348c32.623 0 59.069-26.445 59.069-59.067s-26.446-59.067-59.069-59.067c-32.623 0-59.069 26.445-59.069 59.067s26.446 59.067 59.069 59.067z"
      ></path>
      <path
        fill="#fff"
        fillOpacity="0.08"
        stroke="#fff"
        strokeMiterlimit="10"
        strokeOpacity="0.2"
        strokeWidth="0.613"
        d="M765.426 357.997c25.8 0 46.716-20.915 46.716-46.715 0-25.8-20.916-46.715-46.716-46.715-25.801 0-46.717 20.915-46.717 46.715 0 25.8 20.916 46.715 46.717 46.715z"
      ></path>
      <path
        fill="#2AAC02"
        stroke="#fff"
        strokeMiterlimit="10"
        strokeOpacity="0.3"
        strokeWidth="0.613"
        d="M765.426 345.42c18.855 0 34.139-15.284 34.139-34.138s-15.284-34.138-34.139-34.138c-18.854 0-34.138 15.284-34.138 34.138s15.284 34.138 34.138 34.138z"
      ></path>
      <path fill="#fff" d="M766.099 284.331l-.449 1.123v34.138l.449.224 15.722-9.208-15.722-26.277z"></path>
      <path
        fill="#fff"
        d="M766.1 284.331l-15.947 26.277 15.947 9.208v-35.485zM766.1 322.96l-.225.225v12.128l.225.449 15.721-22.235-15.721 9.433z"
      ></path>
      <path
        fill="#fff"
        d="M766.1 335.762V322.96l-15.947-9.433 15.947 22.235zM766.1 319.815l15.722-9.208-15.722-7.187v16.395z"
      ></path>
      <path fill="#fff" d="M750.153 310.607l15.947 9.208V303.42l-15.947 7.187z"></path>
      <path
        fill="#fff"
        fillOpacity="0.08"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.613"
        d="M501.525 802.461c5.954 0 10.78-4.826 10.78-10.78s-4.826-10.781-10.78-10.781-10.781 4.827-10.781 10.781c0 5.954 4.827 10.78 10.781 10.78z"
      ></path>
      <path
        fill="#000"
        stroke="#fff"
        strokeMiterlimit="10"
        strokeOpacity="0.1"
        strokeWidth="1.226"
        d="M230.211 680.508c11.288 0 20.438-9.15 20.438-20.437 0-11.288-9.15-20.438-20.438-20.438-11.288 0-20.439 9.15-20.439 20.438 0 11.287 9.151 20.437 20.439 20.437z"
      ></path>
      <path
        fill="#fff"
        fillOpacity="0.08"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.613"
        d="M230.212 670.852c5.954 0 10.78-4.826 10.78-10.78s-4.826-10.78-10.78-10.78-10.781 4.826-10.781 10.78 4.827 10.78 10.781 10.78zM311.066 900.16c5.954 0 10.78-4.827 10.78-10.781 0-5.953-4.826-10.78-10.78-10.78s-10.781 4.827-10.781 10.78c0 5.954 4.827 10.781 10.781 10.781z"
      ></path>
      <path
        fill="#000"
        stroke="#fff"
        strokeMiterlimit="10"
        strokeOpacity="0.1"
        strokeWidth="1.226"
        d="M324.318 642.778c11.287 0 20.438-9.15 20.438-20.438 0-11.287-9.151-20.438-20.438-20.438-11.288 0-20.439 9.151-20.439 20.438 0 11.288 9.151 20.438 20.439 20.438z"
      ></path>
      <path
        fill="#fff"
        fillOpacity="0.08"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.613"
        d="M324.318 633.121c5.954 0 10.78-4.826 10.78-10.78s-4.826-10.78-10.78-10.78-10.781 4.826-10.781 10.78 4.827 10.78 10.781 10.78zM662.112 875.004c5.954 0 10.78-4.827 10.78-10.78 0-5.954-4.826-10.781-10.78-10.781s-10.781 4.827-10.781 10.781c0 5.953 4.827 10.78 10.781 10.78z"
      ></path>
      <path
        fill="#fff"
        fillOpacity="0.1"
        stroke="#fff"
        strokeMiterlimit="10"
        strokeOpacity="0.1"
        strokeWidth="1.226"
        d="M501.525 957.205c5.954 0 10.78-4.826 10.78-10.78s-4.826-10.78-10.78-10.78-10.781 4.826-10.781 10.78 4.827 10.78 10.781 10.78zM230.212 757.318c5.954 0 10.78-4.827 10.78-10.78 0-5.954-4.826-10.781-10.78-10.781s-10.781 4.827-10.781 10.781c0 5.953 4.827 10.78 10.781 10.78zM868.29 960.125c5.954 0 10.781-4.827 10.781-10.781 0-5.953-4.827-10.78-10.781-10.78-5.954 0-10.78 4.827-10.78 10.78 0 5.954 4.826 10.781 10.78 10.781zM427.408 1057.15c5.954 0 10.78-4.83 10.78-10.78 0-5.96-4.826-10.78-10.78-10.78s-10.781 4.82-10.781 10.78c0 5.95 4.827 10.78 10.781 10.78zM470.755 1142.94c5.954 0 10.78-4.83 10.78-10.78 0-5.95-4.826-10.78-10.78-10.78s-10.781 4.83-10.781 10.78c0 5.95 4.827 10.78 10.781 10.78zM711.522 927.783c5.954 0 10.781-4.826 10.781-10.78s-4.827-10.78-10.781-10.78c-5.954 0-10.781 4.826-10.781 10.78s4.827 10.78 10.781 10.78zM787.661 717.342c5.954 0 10.78-4.827 10.78-10.78 0-5.954-4.826-10.781-10.78-10.781s-10.781 4.827-10.781 10.781c0 5.953 4.827 10.78 10.781 10.78zM722.304 474.335c5.954 0 10.78-4.826 10.78-10.78s-4.826-10.781-10.78-10.781-10.781 4.827-10.781 10.781c0 5.954 4.827 10.78 10.781 10.78zM672.667 474.335c5.954 0 10.78-4.826 10.78-10.78s-4.826-10.781-10.78-10.781-10.781 4.827-10.781 10.781c0 5.954 4.827 10.78 10.781 10.78zM765.425 426.497c5.954 0 10.781-4.826 10.781-10.78s-4.827-10.78-10.781-10.78c-5.954 0-10.78 4.826-10.78 10.78s4.826 10.78 10.78 10.78zM623.705 768.099c5.954 0 10.781-4.827 10.781-10.781 0-5.953-4.827-10.78-10.781-10.78-5.954 0-10.781 4.827-10.781 10.78 0 5.954 4.827 10.781 10.781 10.781zM649.309 927.783c5.954 0 10.781-4.826 10.781-10.78s-4.827-10.78-10.781-10.78c-5.953 0-10.78 4.826-10.78 10.78s4.827 10.78 10.78 10.78zM576.539 875.004c5.954 0 10.781-4.827 10.781-10.78 0-5.954-4.827-10.781-10.781-10.781-5.954 0-10.781 4.827-10.781 10.781 0 5.953 4.827 10.78 10.781 10.78z"
      ></path>
      <path
        fill="#fff"
        fillOpacity="0.08"
        stroke="#fff"
        strokeMiterlimit="10"
        strokeOpacity="0.1"
        strokeWidth="0.613"
        d="M470.53 464.003c58.672 0 106.234-47.561 106.234-106.231 0-58.67-47.562-106.231-106.234-106.231-58.671 0-106.234 47.561-106.234 106.231 0 58.67 47.563 106.231 106.234 106.231z"
      ></path>
      <path
        fill="#2AAC02"
        stroke="#fff"
        strokeMiterlimit="10"
        strokeWidth="0.5"
        d="M470.53 435.032c42.671 0 77.262-34.59 77.262-77.259s-34.591-77.259-77.262-77.259c-42.67 0-77.261 34.59-77.261 77.259s34.591 77.259 77.261 77.259z"
      ></path>
      <path
        fill="#fff"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="M486.925 387.643v15.496H473.45v-13.25h-8.311v13.25h-13.7v-13.25h-7.636v-63.784h7.636v-13.251h13.7v13.251h8.311v-13.251h13.475v16.171c5.84 2.919 8.535 7.86 8.535 14.822 0 6.963-2.246 11.679-6.963 14.374 5.391 2.246 8.311 6.513 8.311 13.026.224 7.861-3.145 13.476-9.883 16.396zm-18.417-47.389c-2.246 0-4.267 0-5.615.225v12.352h5.615c2.022 0 4.043-.225 5.615-.674.899-1.347 1.348-3.144 1.348-5.614 0-4.268-2.021-6.289-6.963-6.289zm-5.839 36.159c1.572 0 4.043.225 6.738.225 2.246 0 4.267-.225 5.839-.674.674-1.123 1.123-2.92 1.123-4.941 0-3.818-2.021-5.839-6.513-5.839h-7.187v11.229z"
      ></path>
      <path
        fill="#fff"
        d="M334.649 326.555l177.432-89.162s15.048 9.208 30.32 34.137c-25.379 13.476-201.238 99.494-201.238 99.494-6.514-15.272-6.514-44.469-6.514-44.469zM347.9 385.847L549.139 285.23s2.021 3.369 4.042 8.984c2.022 5.615-198.543 103.312-198.543 103.312l-6.738-11.679z"
        opacity="0.2"
      ></path>
      <path
        fill="#2969FF"
        d="M327.911 346.993s-131.164 22.908-138.127 39.303c-6.962 16.395 57.048 8.085 141.047-24.93"
      ></path>
      <path
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="1.226"
        d="M327.911 346.993s-131.164 22.908-138.127 39.303c-6.962 16.395 57.048 8.085 141.047-24.93"
      ></path>
      <path
        fill="#2969FF"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="1.226"
        d="M541.054 252.44c-41.326-52.33-117.24-61.313-169.795-19.989-52.331 41.325-61.315 117.237-19.99 169.791 41.326 52.554 117.24 61.313 169.796 19.988 52.331-41.324 61.315-117.461 19.989-169.79zM357.783 397.076c-38.406-48.736-30.096-119.482 18.641-157.887 48.738-38.405 119.486-30.095 157.892 18.641 38.406 48.736 30.096 119.482-18.642 157.887-48.513 38.405-119.261 30.095-157.891-18.641z"
      ></path>
      <path
        fill="#00D28A"
        stroke="#fff"
        strokeMiterlimit="10"
        d="M324.318 295.786c39.693 0 71.871-32.177 71.871-71.869s-32.178-71.869-71.871-71.869c-39.694 0-71.871 32.177-71.871 71.869s32.177 71.869 71.871 71.869z"
      ></path>
      <path
        fill="#fff"
        stroke="#1D1D1B"
        strokeMiterlimit="10"
        strokeWidth="0.613"
        d="M318.703 259.851c-2.246 0-4.267-.898-6.064-2.47l-25.604-24.031c-3.594-3.369-3.594-8.759-.449-12.353 3.369-3.593 8.759-3.593 12.353-.449l18.641 17.518 34.813-46.715c2.919-3.818 8.31-4.716 12.128-1.796 3.818 2.919 4.716 8.309 1.797 12.128l-40.652 54.8c-1.573 2.021-3.819 3.144-6.289 3.368h-.674z"
      ></path>
      <path
        stroke="#fff"
        strokeMiterlimit="10"
        strokeOpacity="0.1"
        strokeWidth="1.226"
        d="M624.379 706.787v-8.76c0-11.903 9.658-21.56 21.561-21.56h3.145"
      ></path>
      <path
        fill="#fff"
        fillOpacity="0.08"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.613"
        d="M695.8 710.605c18.731 0 33.914-15.183 33.914-33.913 0-18.73-15.183-33.913-33.914-33.913-18.73 0-33.914 15.183-33.914 33.913 0 18.73 15.184 33.913 33.914 33.913z"
      ></path>
      <path
        fill="#fff"
        fillOpacity="0.08"
        stroke="#fff"
        strokeMiterlimit="10"
        strokeOpacity="0.1"
        strokeWidth="0.613"
        d="M695.8 701.396c13.644 0 24.706-11.061 24.706-24.705 0-13.644-11.062-24.705-24.706-24.705-13.645 0-24.706 11.061-24.706 24.705 0 13.644 11.061 24.705 24.706 24.705z"
      ></path>
      <path
        fill="#fff"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.613"
        d="M705.458 663.889h4.042l-8.31 9.208c-2.919 3.369-7.861 3.369-10.78 0l-8.31-9.208h4.042l6.289 6.962a4.502 4.502 0 006.738 0l6.289-6.962zM686.142 689.715H682.1l8.31-9.432c2.919-3.369 7.861-3.369 10.78 0l8.31 9.432h-4.042l-6.289-7.187a4.502 4.502 0 00-6.738 0l-6.289 7.187z"
      ></path>
      <path
        stroke="#fff"
        strokeMiterlimit="10"
        strokeOpacity="0.1"
        strokeWidth="1.226"
        d="M624.155 712.176v-26.053c0-8.534-6.963-15.496-15.722-15.496l-16.396.224c-8.534 0-15.722-6.962-15.722-15.496V627.73"
      ></path>
      <path
        fill="#fff"
        fillOpacity="0.08"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.613"
        d="M579.01 615.602c18.73 0 33.914-15.183 33.914-33.913 0-18.73-15.184-33.913-33.914-33.913-18.73 0-33.914 15.183-33.914 33.913 0 18.73 15.184 33.913 33.914 33.913z"
      ></path>
      <path
        fill="#fff"
        fillOpacity="0.08"
        stroke="#fff"
        strokeMiterlimit="10"
        strokeOpacity="0.1"
        strokeWidth="0.613"
        d="M579.01 606.394c13.645 0 24.706-11.061 24.706-24.705 0-13.644-11.061-24.705-24.706-24.705-13.644 0-24.705 11.061-24.705 24.705 0 13.644 11.061 24.705 24.705 24.705z"
      ></path>
      <path
        fill="#fff"
        stroke="#1D1D1B"
        strokeMiterlimit="10"
        strokeWidth="0.613"
        d="M584.401 591.122v4.94h-4.268v-4.267h-2.695v4.267h-4.267v-4.267h-2.695v-20.437h2.47v-4.268h4.267v4.268H579.909v-4.268h4.267v5.166c1.797.898 2.695 2.47 2.695 4.716s-.674 3.818-2.246 4.717c1.797.673 2.695 2.021 2.695 4.267.225 2.47-.898 4.267-2.919 5.166zm-6.065-15.048h-1.796v4.043h1.796c.674 0 1.348 0 1.797-.225.225-.449.449-1.123.449-1.797 0-1.347-.673-2.021-2.246-2.021zm-1.796 11.454h2.246c.673 0 1.347 0 1.796-.225.225-.449.45-.898.45-1.572 0-1.123-.674-1.796-2.022-1.796h-2.246v3.593h-.224z"
      ></path>
      <path
        stroke="#fff"
        strokeMiterlimit="10"
        strokeOpacity="0.1"
        strokeWidth="1.226"
        d="M331.28 889.377h17.518c43.348 0 78.385 35.036 78.385 78.382M656.72 1623.79v-69.4l-50.534 22.01v-54.58M656.721 1584.04l61.764-29.43v-77.7l-44.92 20.88"
      ></path>
      <path
        stroke="#fff"
        strokeMiterlimit="10"
        strokeOpacity="0.1"
        strokeWidth="1.226"
        d="M673.96 1502.73c.522-6.06-2.56-11.27-6.886-11.64-4.325-.38-8.255 4.23-8.778 10.29-.523 6.05 2.56 11.26 6.885 11.64 4.326.37 8.256-4.24 8.779-10.29zM614.015 1511.67c.523-6.05-2.56-11.26-6.885-11.64-4.326-.37-8.256 4.24-8.779 10.29-.522 6.06 2.56 11.27 6.886 11.64 4.325.38 8.255-4.23 8.778-10.29zM656.721 1554.39l33.465-15.27M705.252 1534.64c.522-6.05-2.56-11.27-6.886-11.64-4.325-.37-8.255 4.23-8.778 10.29-.523 6.05 2.56 11.27 6.885 11.64 4.326.37 8.256-4.23 8.779-10.29zM397.985 1505.88l52.106 21.56 34.813 14.37v49.64l-51.208-21.79M447.621 1486.11v40.21M484.904 1566.29l42.224 17.75M455.465 1475.5c.242-6.08-3.078-11.14-7.416-11.31-4.338-.18-8.051 4.61-8.293 10.68-.242 6.07 3.078 11.14 7.416 11.31 4.338.17 8.051-4.61 8.293-10.68zM535.764 1597.23c4.323-.4 7.383-5.62 6.834-11.67-.549-6.06-4.499-10.65-8.823-10.25-4.324.39-7.384 5.61-6.834 11.67.549 6.05 4.499 10.64 8.823 10.25z"
      ></path>
      <path
        stroke="#fff"
        strokeMiterlimit="10"
        strokeOpacity="0.1"
        strokeWidth="1.226"
        d="M427.058 1577.23c4.323-.4 7.383-5.62 6.834-11.67-.549-6.06-4.499-10.64-8.823-10.25-4.324.39-7.384 5.61-6.834 11.67.549 6.05 4.499 10.64 8.823 10.25zM647.288 1378.09l-80.855 35.93v-274"
      ></path>
      <path
        fill="#fff"
        fillOpacity="0.1"
        stroke="#fff"
        strokeMiterlimit="10"
        strokeOpacity="0.1"
        strokeWidth="1.226"
        d="M566.433 1153.27c6.822 0 12.353-5.53 12.353-12.35 0-6.82-5.531-12.35-12.353-12.35s-12.353 5.53-12.353 12.35c0 6.82 5.531 12.35 12.353 12.35z"
      ></path>
      <path
        stroke="#fff"
        strokeMiterlimit="10"
        strokeOpacity="0.1"
        strokeWidth="1.226"
        d="M594.956 1327.1v-82.2c0-12.12 9.882-22.01 22.011-22.01 31.219 0 56.598-25.37 56.598-56.59v-54.35c0-19.09 15.497-34.59 34.588-34.59h143.742"
      ></path>
      <path
        fill="#000"
        stroke="#fff"
        strokeMiterlimit="10"
        strokeOpacity="0.1"
        strokeWidth="1.226"
        d="M672.891 1164.95c11.288 0 20.439-9.15 20.439-20.44 0-11.28-9.151-20.43-20.439-20.43-11.287 0-20.438 9.15-20.438 20.43 0 11.29 9.151 20.44 20.438 20.44z"
      ></path>
      <path
        fill="#fff"
        fillOpacity="0.08"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.613"
        d="M672.892 1155.29c5.954 0 10.781-4.82 10.781-10.78 0-5.95-4.827-10.78-10.781-10.78-5.954 0-10.781 4.83-10.781 10.78 0 5.96 4.827 10.78 10.781 10.78z"
      ></path>
      <path
        fill="#000"
        stroke="#fff"
        strokeMiterlimit="10"
        strokeOpacity="0.1"
        strokeWidth="1.226"
        d="M870.537 1116.66c21.708 0 39.305-17.59 39.305-39.3 0-21.71-17.597-39.3-39.305-39.3-21.707 0-39.304 17.59-39.304 39.3 0 21.71 17.597 39.3 39.304 39.3z"
      ></path>
      <path
        fill="#fff"
        fillOpacity="0.08"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.613"
        d="M870.537 1111.27c18.73 0 33.914-15.18 33.914-33.91 0-18.73-15.184-33.91-33.914-33.91-18.73 0-33.914 15.18-33.914 33.91 0 18.73 15.184 33.91 33.914 33.91z"
      ></path>
      <path
        fill="#fff"
        fillOpacity="0.08"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.613"
        d="M870.538 1102.07c13.645 0 24.706-11.06 24.706-24.71 0-13.64-11.061-24.7-24.706-24.7-13.644 0-24.705 11.06-24.705 24.7 0 13.65 11.061 24.71 24.705 24.71z"
      ></path>
      <path
        stroke="#fff"
        strokeMiterlimit="10"
        strokeOpacity="0.1"
        strokeWidth="1.226"
        d="M625.053 1433.56l-92.084 41.55v100.17M493.888 1438.73l62.662-28.3v-92.53M553.631 1437.38l33.016-15.72v-117.24"
      ></path>
      <path
        stroke="#fff"
        strokeMiterlimit="10"
        strokeOpacity="0.1"
        strokeWidth="1.226"
        d="M517.695 1371.8l61.315 21.11v-118.36M488.722 1445.46c4.218 0 7.637-1.71 7.637-3.81 0-2.11-3.419-3.82-7.637-3.82-4.217 0-7.636 1.71-7.636 3.82 0 2.1 3.419 3.81 7.636 3.81zM548.24 1444.12c4.218 0 7.637-1.71 7.637-3.82s-3.419-3.82-7.637-3.82c-4.217 0-7.636 1.71-7.636 3.82s3.419 3.82 7.636 3.82zM671.319 1418.74c4.218 0 7.637-1.71 7.637-3.82s-3.419-3.82-7.637-3.82c-4.217 0-7.636 1.71-7.636 3.82s3.419 3.82 7.636 3.82zM665.929 1412.22l-53.904-18.41"
      ></path>
      <path
        fill="#fff"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.613"
        d="M870.537 1059.17l-.225.9v24.03l.225.22 11.229-6.51-11.229-18.64z"
      ></path>
      <path
        fill="#fff"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.613"
        d="M870.536 1059.17l-11.229 18.64 11.229 6.51v-25.15zM870.537 1086.57V1095.78l11.23-15.95-11.23 6.74zM870.537 1095.78v-9.21l-11.23-6.74 11.23 15.95zM870.537 1084.32l11.23-6.51-11.23-5.17v11.68z"
      ></path>
      <path
        fill="#fff"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.613"
        d="M859.307 1077.81l11.23 6.51v-11.68l-11.23 5.17zM440.434 739.353v-15.272c0-2.246-.674-3.818-2.695-4.941-4.492-2.471-8.759-5.166-13.027-7.861-.898-.674-1.347-1.123-1.347-2.246v-7.636c0-1.797 1.123-2.47 2.695-1.572 5.615 3.144 11.454 6.513 16.845 9.882.898.449 1.572 2.021 1.572 3.144.224 7.636 0 15.048 0 22.684 0 2.47-2.246 2.246-4.043 3.818z"
      ></path>
      <path
        fill="#fff"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.613"
        d="M432.574 743.394v-7.411c0-2.022-.674-3.369-2.471-4.268-4.267-2.47-8.534-5.165-12.802-7.636-1.123-.674-1.797-1.347-1.572-2.919v-7.636c0-1.797.898-2.471 2.471-1.573 5.839 3.369 11.454 6.513 17.069 10.107.674.449 1.348 1.797 1.572 2.695.225 5.166.225 10.331 0 15.497 0 2.695-2.695 2.246-3.818 3.593l-.449-.449z"
      ></path>
      <path
        fill="#fff"
        d="M428.755 740.7v3.818c0 2.021-1.348 2.695-2.92 1.796-5.615-3.369-11.005-6.737-16.396-10.106-.898-.674-1.572-2.022-1.572-3.145-.224-2.245-.224-4.716 0-7.186 0-2.022.899-2.471 2.695-1.573a634.33 634.33 0 0116.62 9.658c.899.674 1.573 2.021 1.797 3.144.225 1.123 0 2.471-.224 3.594 0 0 .224 0 0 0z"
      ></path>
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.613"
        d="M428.755 740.7v3.818c0 2.021-1.348 2.695-2.92 1.796-5.615-3.369-11.005-6.737-16.396-10.106-.898-.674-1.572-2.022-1.572-3.145-.224-2.245-.224-4.716 0-7.186 0-2.022.899-2.471 2.695-1.573a634.33 634.33 0 0116.62 9.658c.899.674 1.573 2.021 1.797 3.144.225 1.123 0 2.471-.224 3.594zm0 0c.224 0 0 0 0 0z"
      ></path>
      <path
        fill="#fff"
        stroke="#181E23"
        strokeMiterlimit="10"
        strokeWidth="0.613"
        d="M862.675 812.793h-6.513l8.759 13.026 3.145-4.941-5.391-8.085z"
      ></path>
      <path
        fill="#000"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.613"
        d="M869.189 832.108l5.39 8.085h6.738l-8.759-12.802-3.369 4.717z"
      ></path>
      <path
        fill="#fff"
        stroke="#181E23"
        strokeMiterlimit="10"
        strokeWidth="0.613"
        d="M874.579 812.793l-5.84 8.759-3.368 4.941-9.209 13.7h6.513l6.064-8.759 3.145-4.941 9.433-13.7h-6.738z"
      ></path>
      <path
        fill="#fff"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.613"
        d="M814.612 590.897c5.166.449 8.759 2.695 10.781 6.962 3.368 6.963-1.123 15.272-8.76 16.62-.898.225-1.797.225-2.695.225-1.797.224-3.369 1.572-3.818 3.368-.225.674-.225 1.573-.449 2.246-.225.899-1.123 1.572-2.022 1.348-.898-.225-1.572-1.123-1.347-2.021.898-3.819 1.572-7.412 2.47-11.23l1.348-6.064c.225-.898 1.123-1.572 2.021-1.347.899.224 1.348 1.122 1.348 2.021-.449 2.47-1.123 4.941-1.572 7.187 0 .449-.225.674-.225 1.123 0 .224 0 .224.225.224 1.347-.224 2.695-.224 4.042-.449 3.594-.449 6.514-3.369 7.188-6.738.898-4.941-2.471-9.432-7.412-10.106-4.492-.674-8.759 2.695-9.433 7.411-.225 1.348 0 2.695.449 3.818.225.674 0 1.572-.674 2.022-.674.449-1.347.449-2.021 0-.225-.225-.449-.45-.674-.899-2.246-6.737 1.797-13.7 8.759-15.272.674-.449 1.797-.449 2.471-.449z"
      ></path>
      <path
        fill="#fff"
        fillOpacity="0.08"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.613"
        d="M816.858 620.093a2.013 2.013 0 01-2.022 2.021 2.012 2.012 0 01-2.021-2.021c0-1.123.898-2.021 2.021-2.021 1.123 0 2.022.898 2.022 2.021z"
      ></path>
      <path
        fill="#fff"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.613"
        d="M961.724 683.204l-.45 1.123v32.341l.45.224 15.048-8.759-15.048-24.929z"
      ></path>
      <path
        fill="#fff"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.613"
        d="M961.723 683.204l-15.273 24.929 15.273 8.759v-33.688zM961.723 719.812l-.225.224v11.454l.225.674 15.048-21.111-15.048 8.759z"
      ></path>
      <path
        fill="#fff"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.613"
        d="M961.723 732.164v-12.352l-15.273-8.759 15.273 21.111zM961.724 716.893l15.048-8.759-15.048-6.963v15.722zM946.45 708.134l15.273 8.759v-15.722l-15.273 6.963zM944.655 510.268c.674-.224 1.347-.449 1.797-.898 1.123-.674 1.796-1.797 1.572-3.369-.674-9.208 5.165-17.294 13.925-19.539 5.39-1.348 10.331-.674 15.048 2.245.224.225.449.45.898.674-1.123.674-2.246 1.123-3.144 1.572-.225 0-.674 0-.899-.224-8.984-4.492-19.764.674-22.01 10.556-.449 1.796-.449 3.368-.449 5.165 0 0 .224 0 .224.225 12.578-6.289 25.155-12.802 37.733-19.315v3.369c0 .224-.45.674-.674.674l-20.888 10.78c-7.636 4.043-15.497 7.861-23.133 11.903v-3.818zM944.653 517.905c.225-.224.674-.224.899-.449 14.374-7.187 28.524-14.598 42.898-21.785.224-.225.673-.225.898-.449v3.593a.483.483 0 01-.449.449l-1.348.674c-1.123.674-1.796 2.021-1.572 3.369.674 9.208-5.166 17.293-14.149 19.764-.899.224-1.797.449-2.92.674h-4.043c-.225 0-.449-.225-.674-.225-2.695-.449-5.166-1.347-7.636-2.92-.225-.224-.449-.449-.898-.673l2.695-1.348c.674-.449 1.123-.225 1.572 0 8.759 4.267 19.315-.449 21.786-9.882.449-2.021.674-3.818.449-6.064-.449.225-.674.225-.898.449-6.289 3.145-12.578 6.513-19.091 9.658-5.84 2.919-11.904 6.064-17.743 8.983.224-1.123.224-2.47.224-3.818z"
      ></path>
      <path
        fill="#fff"
        stroke="#1D1D1B"
        strokeMiterlimit="10"
        strokeWidth="0.613"
        d="M328.584 537.221c-.898-3.369-1.797-6.738-2.695-10.331 0 .224-.225.224-.225.224-1.796 3.145-3.818 6.513-5.614 9.658v.224c0 .225-.225.225-.225.225h-4.492c0-.225 0-.225.225-.225 2.919-5.165 5.839-10.106 8.759-15.272.224-.224.224-.449 0-.674-.449-1.572-.899-3.368-1.348-4.941v-.224c0 .224-.224.224-.224.224-2.92 4.941-5.84 10.107-8.76 15.048-1.123 2.021-2.246 3.818-3.369 5.839 0 .225-.224.225-.449.225H305.9l15.497-26.951h4.267c.674 2.246 1.123 4.492 1.797 6.738h4.268c0 .224-.225.224-.225.224-.898 1.572-1.797 3.145-2.695 4.492 0 .225-.225.225 0 .449l4.043 14.823v.225h-4.268z"
      ></path>
      <defs>
        <filter
          id="filter0_d_718_10273"
          width="486.627"
          height="453.515"
          x="299.357"
          y="1282.46"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dx="-27" dy="4"></feOffset>
          <feGaussianBlur stdDeviation="35"></feGaussianBlur>
          <feComposite in2="hardAlpha" operator="out"></feComposite>
          <feColorMatrix values="0 0 0 0 0.229167 0 0 0 0 0.436453 0 0 0 0 0.916667 0 0 0 0.2 0"></feColorMatrix>
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_718_10273"></feBlend>
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_718_10273" result="shape"></feBlend>
        </filter>
      </defs>
    </svg>
  );
};
